import { defineMessages } from 'react-intl';
var mapMassages = defineMessages({
  "北京": {
    "id": "北京"
  },
  "天津": {
    "id": "天津"
  },
  "重庆": {
    "id": "重庆"
  },
  "上海": {
    "id": "上海"
  },
  "海外": {
    "id": "海外"
  },
  "凡": {
    "id": "凡"
  },
  "比亚克拉拉": {
    "id": "比亚克拉拉"
  },
  "瓦努阿图": {
    "id": "瓦努阿图"
  },
  "伊甘加": {
    "id": "伊甘加"
  },
  "阿拉拉特": {
    "id": "阿拉拉特"
  },
  "索斯诺维茨": {
    "id": "索斯诺维茨"
  },
  "埃因霍芬": {
    "id": "埃因霍芬"
  },
  "布尔吉·布阿雷里吉": {
    "id": "布尔吉·布阿雷里吉"
  },
  "库里滕加": {
    "id": "库里滕加"
  },
  "东加里曼丹": {
    "id": "东加里曼丹"
  },
  "波隆纳鲁沃": {
    "id": "波隆纳鲁沃"
  },
  "塞拉亚": {
    "id": "塞拉亚"
  },
  "科伦坡": {
    "id": "科伦坡"
  },
  "波德拉夫": {
    "id": "波德拉夫"
  },
  "关岛": {
    "id": "关岛"
  },
  "列日": {
    "id": "列日"
  },
  "萨卡里亚": {
    "id": "萨卡里亚"
  },
  "阿杜": {
    "id": "阿杜"
  },
  "西方": {
    "id": "西方"
  },
  "梅塔": {
    "id": "梅塔"
  },
  "鲁夸": {
    "id": "鲁夸"
  },
  "亚眠": {
    "id": "亚眠"
  },
  "班斯卡-比斯特里察": {
    "id": "班斯卡-比斯特里察"
  },
  "舍卜沃": {
    "id": "舍卜沃"
  },
  "华雷斯港": {
    "id": "华雷斯港"
  },
  "哥伦比亚": {
    "id": "哥伦比亚"
  },
  "马哈卡利": {
    "id": "马哈卡利"
  },
  "松恩－菲尤拉讷": {
    "id": "松恩－菲尤拉讷"
  },
  "博克龙": {
    "id": "博克龙"
  },
  "西希兰": {
    "id": "西希兰"
  },
  "圣胡利娅－德洛里亚": {
    "id": "圣胡利娅－德洛里亚"
  },
  "普图马约": {
    "id": "普图马约"
  },
  "南奔": {
    "id": "南奔"
  },
  "下蒙德古": {
    "id": "下蒙德古"
  },
  "波尼": {
    "id": "波尼"
  },
  "阿塞拜疆": {
    "id": "阿塞拜疆"
  },
  "吕伐登": {
    "id": "吕伐登"
  },
  "奥什": {
    "id": "奥什"
  },
  "多德雷赫特": {
    "id": "多德雷赫特"
  },
  "西胡德": {
    "id": "西胡德"
  },
  "贾朗达尔": {
    "id": "贾朗达尔"
  },
  "法兰克福": {
    "id": "法兰克福"
  },
  "萨索尔堡": {
    "id": "萨索尔堡"
  },
  "伊尔比德": {
    "id": "伊尔比德"
  },
  "加拉茨": {
    "id": "加拉茨"
  },
  "因蒂布卡": {
    "id": "因蒂布卡"
  },
  "瓦卡塔尼": {
    "id": "瓦卡塔尼"
  },
  "加利福尼亚": {
    "id": "加利福尼亚"
  },
  "爱达荷": {
    "id": "爱达荷"
  },
  "福井": {
    "id": "福井"
  },
  "马海卡-伯比斯": {
    "id": "马海卡-伯比斯"
  },
  "西米斯": {
    "id": "西米斯"
  },
  "费利杜": {
    "id": "费利杜"
  },
  "埃斯昆特拉": {
    "id": "埃斯昆特拉"
  },
  "普塔勒姆": {
    "id": "普塔勒姆"
  },
  "沙特阿拉伯": {
    "id": "沙特阿拉伯"
  },
  "拉合尔": {
    "id": "拉合尔"
  },
  "瓦拉日丁": {
    "id": "瓦拉日丁"
  },
  "汉班托特": {
    "id": "汉班托特"
  },
  "董里": {
    "id": "董里"
  },
  "第乌": {
    "id": "第乌"
  },
  "俄勒冈": {
    "id": "俄勒冈"
  },
  "香港特别行政区": {
    "id": "香港特别行政区"
  },
  "阿马帕": {
    "id": "阿马帕"
  },
  "内尔斯普雷特": {
    "id": "内尔斯普雷特"
  },
  "耶尔韦": {
    "id": "耶尔韦"
  },
  "塞古": {
    "id": "塞古"
  },
  "洛斯里奥斯": {
    "id": "洛斯里奥斯"
  },
  "罗萨里奥": {
    "id": "罗萨里奥"
  },
  "上瓦尔登": {
    "id": "上瓦尔登"
  },
  "卡姆文盖": {
    "id": "卡姆文盖"
  },
  "特拉帕尼": {
    "id": "特拉帕尼"
  },
  "波萨达斯": {
    "id": "波萨达斯"
  },
  "北标": {
    "id": "北标"
  },
  "多哥": {
    "id": "多哥"
  },
  "马其顿": {
    "id": "马其顿"
  },
  "多哈": {
    "id": "多哈"
  },
  "罗赖马": {
    "id": "罗赖马"
  },
  "陶格夫皮尔斯": {
    "id": "陶格夫皮尔斯"
  },
  "河口": {
    "id": "河口"
  },
  "马瓜尼": {
    "id": "马瓜尼"
  },
  "钦布": {
    "id": "钦布"
  },
  "苏布拉开马": {
    "id": "苏布拉开马"
  },
  "汤加": {
    "id": "汤加"
  },
  "诺夫哥罗德": {
    "id": "诺夫哥罗德"
  },
  "冈比亚": {
    "id": "冈比亚"
  },
  "埃尔祖鲁姆": {
    "id": "埃尔祖鲁姆"
  },
  "埃莫西约": {
    "id": "埃莫西约"
  },
  "阿德拉尔": {
    "id": "阿德拉尔"
  },
  "莱迪史密斯": {
    "id": "莱迪史密斯"
  },
  "奥格斯堡": {
    "id": "奥格斯堡"
  },
  "卡巴罗莱": {
    "id": "卡巴罗莱"
  },
  "利萨拉尔达": {
    "id": "利萨拉尔达"
  },
  "法属南部领地": {
    "id": "法属南部领地"
  },
  "part1": {
    "id": "part1"
  },
  "阿曼": {
    "id": "阿曼"
  },
  "中部地区": {
    "id": "中部地区"
  },
  "卡尼巴达姆": {
    "id": "卡尼巴达姆"
  },
  "顿涅茨克": {
    "id": "顿涅茨克"
  },
  "邓迪": {
    "id": "邓迪"
  },
  "皮乌拉": {
    "id": "皮乌拉"
  },
  "涅恩布库": {
    "id": "涅恩布库"
  },
  "波代诺内": {
    "id": "波代诺内"
  },
  "鲁塞": {
    "id": "鲁塞"
  },
  "卡扬扎": {
    "id": "卡扬扎"
  },
  "广东省": {
    "id": "广东省"
  },
  "马特勒": {
    "id": "马特勒"
  },
  "瓦尔格拉": {
    "id": "瓦尔格拉"
  },
  "圣玛丽": {
    "id": "圣玛丽"
  },
  "科瓦利马": {
    "id": "科瓦利马"
  },
  "贾巴尔普尔": {
    "id": "贾巴尔普尔"
  },
  "奥尔迪诺": {
    "id": "奥尔迪诺"
  },
  "拉赫季": {
    "id": "拉赫季"
  },
  "马拉喀什": {
    "id": "马拉喀什"
  },
  "阿斯图利亚斯": {
    "id": "阿斯图利亚斯"
  },
  "弗雷瑞斯": {
    "id": "弗雷瑞斯"
  },
  "草原区": {
    "id": "草原区"
  },
  "比勒陀利亚": {
    "id": "比勒陀利亚"
  },
  "基尔肯尼": {
    "id": "基尔肯尼"
  },
  "布琼布拉乡村": {
    "id": "布琼布拉乡村"
  },
  "中央区": {
    "id": "中央区"
  },
  "拉格瓦特": {
    "id": "拉格瓦特"
  },
  "乔治": {
    "id": "乔治"
  },
  "洛法": {
    "id": "洛法"
  },
  "布塔布泰": {
    "id": "布塔布泰"
  },
  "巴尔喀什": {
    "id": "巴尔喀什"
  },
  "萨德伯里": {
    "id": "萨德伯里"
  },
  "乌波卢岛": {
    "id": "乌波卢岛"
  },
  "普拉亚": {
    "id": "普拉亚"
  },
  "波萨维纳": {
    "id": "波萨维纳"
  },
  "佩斯": {
    "id": "佩斯"
  },
  "吉布提": {
    "id": "吉布提"
  },
  "塔菲拉": {
    "id": "塔菲拉"
  },
  "奥尔金": {
    "id": "奥尔金"
  },
  "迪基勒区": {
    "id": "迪基勒区"
  },
  "考卡山谷": {
    "id": "考卡山谷"
  },
  "马累": {
    "id": "马累"
  },
  "彭世洛": {
    "id": "彭世洛"
  },
  "中阿连特茹": {
    "id": "中阿连特茹"
  },
  "内乌肯": {
    "id": "内乌肯"
  },
  "阿拉加措特恩": {
    "id": "阿拉加措特恩"
  },
  "代尔祖尔": {
    "id": "代尔祖尔"
  },
  "基尔代尔": {
    "id": "基尔代尔"
  },
  "拉卡": {
    "id": "拉卡"
  },
  "福莫萨": {
    "id": "福莫萨"
  },
  "莫霍特隆": {
    "id": "莫霍特隆"
  },
  "安索阿特吉": {
    "id": "安索阿特吉"
  },
  "希奥利艾": {
    "id": "希奥利艾"
  },
  "阿克托别": {
    "id": "阿克托别"
  },
  "多德卡尼斯": {
    "id": "多德卡尼斯"
  },
  "卡卢坎": {
    "id": "卡卢坎"
  },
  "卡坦扎罗": {
    "id": "卡坦扎罗"
  },
  "圭尔夫": {
    "id": "圭尔夫"
  },
  "阿拉瓜": {
    "id": "阿拉瓜"
  },
  "帕": {
    "id": "帕"
  },
  "弗兰克群岛": {
    "id": "弗兰克群岛"
  },
  "伊里安查亚": {
    "id": "伊里安查亚"
  },
  "吉迪马卡": {
    "id": "吉迪马卡"
  },
  "青森": {
    "id": "青森"
  },
  "柯克拉雷利": {
    "id": "柯克拉雷利"
  },
  "琅南塔": {
    "id": "琅南塔"
  },
  "莫纳斯提尔": {
    "id": "莫纳斯提尔"
  },
  "阿姆哈拉": {
    "id": "阿姆哈拉"
  },
  "巴明吉-班戈兰": {
    "id": "巴明吉-班戈兰"
  },
  "科瓦贝拉": {
    "id": "科瓦贝拉"
  },
  "的里雅斯特": {
    "id": "的里雅斯特"
  },
  "克卢日纳波卡": {
    "id": "克卢日纳波卡"
  },
  "德拉": {
    "id": "德拉"
  },
  "鹿儿岛": {
    "id": "鹿儿岛"
  },
  "科隆": {
    "id": "科隆"
  },
  "艾卜哈": {
    "id": "艾卜哈"
  },
  "布莱尼姆": {
    "id": "布莱尼姆"
  },
  "蓝毗尼": {
    "id": "蓝毗尼"
  },
  "曼谷": {
    "id": "曼谷"
  },
  "危地马拉": {
    "id": "危地马拉"
  },
  "比利时": {
    "id": "比利时"
  },
  "古卢": {
    "id": "古卢"
  },
  "博尔沃": {
    "id": "博尔沃"
  },
  "克雷塔罗": {
    "id": "克雷塔罗"
  },
  "马哈奇卡拉": {
    "id": "马哈奇卡拉"
  },
  "奥拉迪亚": {
    "id": "奥拉迪亚"
  },
  "维厄勒": {
    "id": "维厄勒"
  },
  "巴格马蒂": {
    "id": "巴格马蒂"
  },
  "克孜勒奥尔达": {
    "id": "克孜勒奥尔达"
  },
  "马努斯": {
    "id": "马努斯"
  },
  "乌达兰": {
    "id": "乌达兰"
  },
  "布尔杜尔": {
    "id": "布尔杜尔"
  },
  "古尔代盖": {
    "id": "古尔代盖"
  },
  "缅甸": {
    "id": "缅甸"
  },
  "摩尔曼斯克": {
    "id": "摩尔曼斯克"
  },
  "苏黎世": {
    "id": "苏黎世"
  },
  "比斯特里察": {
    "id": "比斯特里察"
  },
  "伏尔加格勒": {
    "id": "伏尔加格勒"
  },
  "part2": {
    "id": "part2"
  },
  "马夫拉克": {
    "id": "马夫拉克"
  },
  "北海道": {
    "id": "北海道"
  },
  "布雷达": {
    "id": "布雷达"
  },
  "达布罗瓦戈尼察": {
    "id": "达布罗瓦戈尼察"
  },
  "中奥果韦": {
    "id": "中奥果韦"
  },
  "金贾": {
    "id": "金贾"
  },
  "达尼丁": {
    "id": "达尼丁"
  },
  "莱什": {
    "id": "莱什"
  },
  "库内奥": {
    "id": "库内奥"
  },
  "波鸿": {
    "id": "波鸿"
  },
  "巴西利亚": {
    "id": "巴西利亚"
  },
  "铜带": {
    "id": "铜带"
  },
  "圣路易斯波托亚": {
    "id": "圣路易斯波托亚"
  },
  "上奥果韦": {
    "id": "上奥果韦"
  },
  "缅因": {
    "id": "缅因"
  },
  "扎莫希奇": {
    "id": "扎莫希奇"
  },
  "扎布汗": {
    "id": "扎布汗"
  },
  "贝特雁": {
    "id": "贝特雁"
  },
  "卡托维兹": {
    "id": "卡托维兹"
  },
  "柏林": {
    "id": "柏林"
  },
  "阿雷基帕": {
    "id": "阿雷基帕"
  },
  "里贾纳": {
    "id": "里贾纳"
  },
  "丘陵": {
    "id": "丘陵"
  },
  "保尔": {
    "id": "保尔"
  },
  "库斯卡特兰": {
    "id": "库斯卡特兰"
  },
  "摩洛哥": {
    "id": "摩洛哥"
  },
  "苏卢克图": {
    "id": "苏卢克图"
  },
  "沃鲁": {
    "id": "沃鲁"
  },
  "圣基茨和尼维斯": {
    "id": "圣基茨和尼维斯"
  },
  "米尔恩湾": {
    "id": "米尔恩湾"
  },
  "巴拉圭": {
    "id": "巴拉圭"
  },
  "开罗": {
    "id": "开罗"
  },
  "都拉斯": {
    "id": "都拉斯"
  },
  "贝内文托": {
    "id": "贝内文托"
  },
  "加拉加斯": {
    "id": "加拉加斯"
  },
  "纳布勒": {
    "id": "纳布勒"
  },
  "塞蒂夫": {
    "id": "塞蒂夫"
  },
  "巴拉瓜里": {
    "id": "巴拉瓜里"
  },
  "奥洛穆茨": {
    "id": "奥洛穆茨"
  },
  "伊尔库茨克": {
    "id": "伊尔库茨克"
  },
  "休尼克": {
    "id": "休尼克"
  },
  "马乌莱大区": {
    "id": "马乌莱大区"
  },
  "圣伊丽莎白": {
    "id": "圣伊丽莎白"
  },
  "白沙瓦": {
    "id": "白沙瓦"
  },
  "克伦邦": {
    "id": "克伦邦"
  },
  "泰勒马克": {
    "id": "泰勒马克"
  },
  "宗多马": {
    "id": "宗多马"
  },
  "耶梭通": {
    "id": "耶梭通"
  },
  "库尔干": {
    "id": "库尔干"
  },
  "卡卢特勒": {
    "id": "卡卢特勒"
  },
  "加里加尔": {
    "id": "加里加尔"
  },
  "卡米什利": {
    "id": "卡米什利"
  },
  "菲尼克斯群岛": {
    "id": "菲尼克斯群岛"
  },
  "马萨特兰": {
    "id": "马萨特兰"
  },
  "皮奥伊": {
    "id": "皮奥伊"
  },
  "耶洛奈夫": {
    "id": "耶洛奈夫"
  },
  "美属外岛": {
    "id": "美属外岛"
  },
  "吉打": {
    "id": "吉打"
  },
  "加扎勒河": {
    "id": "加扎勒河"
  },
  "图阿马西拉": {
    "id": "图阿马西拉"
  },
  "南澳大利亚": {
    "id": "南澳大利亚"
  },
  "韦希加": {
    "id": "韦希加"
  },
  "宁夏回族自治区": {
    "id": "宁夏回族自治区"
  },
  "西博滕": {
    "id": "西博滕"
  },
  "圣路易斯": {
    "id": "圣路易斯"
  },
  "彭亨": {
    "id": "彭亨"
  },
  "乔罗马": {
    "id": "乔罗马"
  },
  "阿纳姆": {
    "id": "阿纳姆"
  },
  "班加罗尔": {
    "id": "班加罗尔"
  },
  "库尔纳": {
    "id": "库尔纳"
  },
  "哥斯达黎加": {
    "id": "哥斯达黎加"
  },
  "沙耶武里": {
    "id": "沙耶武里"
  },
  "姆巴拉拉": {
    "id": "姆巴拉拉"
  },
  "湖南省": {
    "id": "湖南省"
  },
  "圣马力诺": {
    "id": "圣马力诺"
  },
  "密歇根": {
    "id": "密歇根"
  },
  "弗罗马格尔": {
    "id": "弗罗马格尔"
  },
  "比什凯克市": {
    "id": "比什凯克市"
  },
  "北卡罗来纳": {
    "id": "北卡罗来纳"
  },
  "杰勒法": {
    "id": "杰勒法"
  },
  "阿比扬": {
    "id": "阿比扬"
  },
  "中捷克": {
    "id": "中捷克"
  },
  "怀特霍斯": {
    "id": "怀特霍斯"
  },
  "塔吉克斯坦": {
    "id": "塔吉克斯坦"
  },
  "新城": {
    "id": "新城"
  },
  "立陶宛": {
    "id": "立陶宛"
  },
  "河内": {
    "id": "河内"
  },
  "特兰斯-恩佐亚": {
    "id": "特兰斯-恩佐亚"
  },
  "发罗拉": {
    "id": "发罗拉"
  },
  "科尔察": {
    "id": "科尔察"
  },
  "东巴克利": {
    "id": "东巴克利"
  },
  "东部高地": {
    "id": "东部高地"
  },
  "萨莫拉": {
    "id": "萨莫拉"
  },
  "马萨纳": {
    "id": "马萨纳"
  },
  "塔布克": {
    "id": "塔布克"
  },
  "卢加": {
    "id": "卢加"
  },
  "吉雷松": {
    "id": "吉雷松"
  },
  "本阿鲁斯": {
    "id": "本阿鲁斯"
  },
  "part3": {
    "id": "part3"
  },
  "拉斯帕尔马斯": {
    "id": "拉斯帕尔马斯"
  },
  "曼亚拉": {
    "id": "曼亚拉"
  },
  "穆拉库": {
    "id": "穆拉库"
  },
  "希尤": {
    "id": "希尤"
  },
  "卡塞雷斯": {
    "id": "卡塞雷斯"
  },
  "东南苏拉威西": {
    "id": "东南苏拉威西"
  },
  "秘鲁": {
    "id": "秘鲁"
  },
  "麦哲伦-智利南极大区": {
    "id": "麦哲伦-智利南极大区"
  },
  "里斯本": {
    "id": "里斯本"
  },
  "托托尼卡潘": {
    "id": "托托尼卡潘"
  },
  "马当": {
    "id": "马当"
  },
  "多米斯拉夫格勒": {
    "id": "多米斯拉夫格勒"
  },
  "西阿格德尔": {
    "id": "西阿格德尔"
  },
  "后杭爱": {
    "id": "后杭爱"
  },
  "圣维森特岛": {
    "id": "圣维森特岛"
  },
  "绿山城": {
    "id": "绿山城"
  },
  "阿瓜斯卡连斯特": {
    "id": "阿瓜斯卡连斯特"
  },
  "苏恰瓦": {
    "id": "苏恰瓦"
  },
  "瓜伊尼亚": {
    "id": "瓜伊尼亚"
  },
  "阿尔卡累克": {
    "id": "阿尔卡累克"
  },
  "东部地区": {
    "id": "东部地区"
  },
  "吉隆坡": {
    "id": "吉隆坡"
  },
  "卡萨帕": {
    "id": "卡萨帕"
  },
  "阿斯塔纳市": {
    "id": "阿斯塔纳市"
  },
  "摩纳哥": {
    "id": "摩纳哥"
  },
  "埃及": {
    "id": "埃及"
  },
  "希米亚诺维采": {
    "id": "希米亚诺维采"
  },
  "迪基希": {
    "id": "迪基希"
  },
  "湖泊": {
    "id": "湖泊"
  },
  "菩萨": {
    "id": "菩萨"
  },
  "穆莱蒂武": {
    "id": "穆莱蒂武"
  },
  "摩德纳": {
    "id": "摩德纳"
  },
  "塔拉法尔": {
    "id": "塔拉法尔"
  },
  "东约特兰": {
    "id": "东约特兰"
  },
  "玻利瓦尔": {
    "id": "玻利瓦尔"
  },
  "巴波卢": {
    "id": "巴波卢"
  },
  "比索": {
    "id": "比索"
  },
  "格加尔库尼克": {
    "id": "格加尔库尼克"
  },
  "特克索波": {
    "id": "特克索波"
  },
  "马费滕": {
    "id": "马费滕"
  },
  "蒙彼利埃": {
    "id": "蒙彼利埃"
  },
  "阿伯茨福": {
    "id": "阿伯茨福"
  },
  "川圹": {
    "id": "川圹"
  },
  "马斯卡拉": {
    "id": "马斯卡拉"
  },
  "萨尔蒂约": {
    "id": "萨尔蒂约"
  },
  "久尔贝勒": {
    "id": "久尔贝勒"
  },
  "布拉迪斯拉发": {
    "id": "布拉迪斯拉发"
  },
  "赤道": {
    "id": "赤道"
  },
  "平壤": {
    "id": "平壤"
  },
  "泰基尔达": {
    "id": "泰基尔达"
  },
  "拉农": {
    "id": "拉农"
  },
  "科金博大区": {
    "id": "科金博大区"
  },
  "纳波，奥雷利亚纳": {
    "id": "纳波，奥雷利亚纳"
  },
  "劳滕": {
    "id": "劳滕"
  },
  "库奥皮奥": {
    "id": "库奥皮奥"
  },
  "利摩日": {
    "id": "利摩日"
  },
  "格尔纳利": {
    "id": "格尔纳利"
  },
  "马加丹": {
    "id": "马加丹"
  },
  "南部高地": {
    "id": "南部高地"
  },
  "素攀武里": {
    "id": "素攀武里"
  },
  "慕尼黑": {
    "id": "慕尼黑"
  },
  "罗加兰": {
    "id": "罗加兰"
  },
  "诺尔兰": {
    "id": "诺尔兰"
  },
  "布班扎": {
    "id": "布班扎"
  },
  "卡哈马卡": {
    "id": "卡哈马卡"
  },
  "库尔迪加": {
    "id": "库尔迪加"
  },
  "凯莫": {
    "id": "凯莫"
  },
  "圣何塞": {
    "id": "圣何塞"
  },
  "赫德和麦克唐纳群岛": {
    "id": "赫德和麦克唐纳群岛"
  },
  "布尔古": {
    "id": "布尔古"
  },
  "奈良": {
    "id": "奈良"
  },
  "洛斯莫奇斯": {
    "id": "洛斯莫奇斯"
  },
  "康提": {
    "id": "康提"
  },
  "布尔基恩德": {
    "id": "布尔基恩德"
  },
  "奥夫雷贡城": {
    "id": "奥夫雷贡城"
  },
  "尼亚尼亚": {
    "id": "尼亚尼亚"
  },
  "阿纳德尔": {
    "id": "阿纳德尔"
  },
  "莫拉桑": {
    "id": "莫拉桑"
  },
  "曼贝雷-卡代": {
    "id": "曼贝雷-卡代"
  },
  "乌田纳": {
    "id": "乌田纳"
  },
  "福贾": {
    "id": "福贾"
  },
  "法拉纳": {
    "id": "法拉纳"
  },
  "博阿维斯塔岛": {
    "id": "博阿维斯塔岛"
  },
  "塔甘特": {
    "id": "塔甘特"
  },
  "北蒂拉杜马蒂": {
    "id": "北蒂拉杜马蒂"
  },
  "米纳斯吉拉斯": {
    "id": "米纳斯吉拉斯"
  },
  "约恩苏": {
    "id": "约恩苏"
  },
  "卡拉索": {
    "id": "卡拉索"
  },
  "迪拜": {
    "id": "迪拜"
  },
  "拉斯佩齐亚": {
    "id": "拉斯佩齐亚"
  },
  "科纳克里": {
    "id": "科纳克里"
  },
  "克莱尔": {
    "id": "克莱尔"
  },
  "牙买加": {
    "id": "牙买加"
  },
  "北日德兰": {
    "id": "北日德兰"
  },
  "苏昆毕奥斯": {
    "id": "苏昆毕奥斯"
  },
  "拉奎拉": {
    "id": "拉奎拉"
  },
  "莫达汉": {
    "id": "莫达汉"
  },
  "part4": {
    "id": "part4"
  },
  "北马洛斯马杜卢": {
    "id": "北马洛斯马杜卢"
  },
  "奈梅亨": {
    "id": "奈梅亨"
  },
  "耶夫勒堡": {
    "id": "耶夫勒堡"
  },
  "圣克鲁斯-德特内里费": {
    "id": "圣克鲁斯-德特内里费"
  },
  "科莫埃": {
    "id": "科莫埃"
  },
  "奥多棉吉": {
    "id": "奥多棉吉"
  },
  "坎特": {
    "id": "坎特"
  },
  "乌代布尔": {
    "id": "乌代布尔"
  },
  "湖大区": {
    "id": "湖大区"
  },
  "亚南": {
    "id": "亚南"
  },
  "霍马湾": {
    "id": "霍马湾"
  },
  "占巴塞": {
    "id": "占巴塞"
  },
  "内坦亚": {
    "id": "内坦亚"
  },
  "锡瓦斯": {
    "id": "锡瓦斯"
  },
  "雅沃兹诺": {
    "id": "雅沃兹诺"
  },
  "洛维奇": {
    "id": "洛维奇"
  },
  "威热": {
    "id": "威热"
  },
  "洛贡": {
    "id": "洛贡"
  },
  "格拉玛": {
    "id": "格拉玛"
  },
  "基苏木": {
    "id": "基苏木"
  },
  "托霍延杜": {
    "id": "托霍延杜"
  },
  "科托帕希": {
    "id": "科托帕希"
  },
  "布兰卡港": {
    "id": "布兰卡港"
  },
  "巴兰尼亚": {
    "id": "巴兰尼亚"
  },
  "纳瓦拉": {
    "id": "纳瓦拉"
  },
  "贝尔格莱德": {
    "id": "贝尔格莱德"
  },
  "弗里堡": {
    "id": "弗里堡"
  },
  "海乌姆": {
    "id": "海乌姆"
  },
  "森美兰": {
    "id": "森美兰"
  },
  "特里凡得琅": {
    "id": "特里凡得琅"
  },
  "德尔加多": {
    "id": "德尔加多"
  },
  "鸟取": {
    "id": "鸟取"
  },
  "马努考": {
    "id": "马努考"
  },
  "巴杜勒": {
    "id": "巴杜勒"
  },
  "金迪亚": {
    "id": "金迪亚"
  },
  "里瓦达维亚海军准将城": {
    "id": "里瓦达维亚海军准将城"
  },
  "通布图": {
    "id": "通布图"
  },
  "卡卢加": {
    "id": "卡卢加"
  },
  "奈拜提耶市": {
    "id": "奈拜提耶市"
  },
  "内夫谢希尔": {
    "id": "内夫谢希尔"
  },
  "斯特拉特福德": {
    "id": "斯特拉特福德"
  },
  "蒂华纳": {
    "id": "蒂华纳"
  },
  "菲律宾": {
    "id": "菲律宾"
  },
  "埃瓦": {
    "id": "埃瓦"
  },
  "纳尔奇克": {
    "id": "纳尔奇克"
  },
  "库利科罗": {
    "id": "库利科罗"
  },
  "西博福特": {
    "id": "西博福特"
  },
  "钦博拉索": {
    "id": "钦博拉索"
  },
  "莫内根": {
    "id": "莫内根"
  },
  "那空那育": {
    "id": "那空那育"
  },
  "元山": {
    "id": "元山"
  },
  "清莱": {
    "id": "清莱"
  },
  "埃尔奥罗": {
    "id": "埃尔奥罗"
  },
  "乌兰巴托市": {
    "id": "乌兰巴托市"
  },
  "维多利亚城": {
    "id": "维多利亚城"
  },
  "伊塔普亚": {
    "id": "伊塔普亚"
  },
  "彼得罗巴甫洛夫斯克": {
    "id": "彼得罗巴甫洛夫斯克"
  },
  "拉瓦尔品第": {
    "id": "拉瓦尔品第"
  },
  "努瓦迪布湾": {
    "id": "努瓦迪布湾"
  },
  "扎尔卡": {
    "id": "扎尔卡"
  },
  "艾加伊勒泰": {
    "id": "艾加伊勒泰"
  },
  "雷焦艾米利亚": {
    "id": "雷焦艾米利亚"
  },
  "圣地亚哥-德尔埃斯特罗": {
    "id": "圣地亚哥-德尔埃斯特罗"
  },
  "多伦多": {
    "id": "多伦多"
  },
  "波尔塔瓦": {
    "id": "波尔塔瓦"
  },
  "马斯特里赫特": {
    "id": "马斯特里赫特"
  },
  "安贝诺": {
    "id": "安贝诺"
  },
  "费拉拉": {
    "id": "费拉拉"
  },
  "弗拉季高加索": {
    "id": "弗拉季高加索"
  },
  "焦特布尔": {
    "id": "焦特布尔"
  },
  "基洛夫格勒": {
    "id": "基洛夫格勒"
  },
  "舍基": {
    "id": "舍基"
  },
  "阿尔梅里亚": {
    "id": "阿尔梅里亚"
  },
  "乌克兰": {
    "id": "乌克兰"
  },
  "雪兰莪": {
    "id": "雪兰莪"
  },
  "里加": {
    "id": "里加"
  },
  "米凯利": {
    "id": "米凯利"
  },
  "梅鲁": {
    "id": "梅鲁"
  },
  "奥格雷": {
    "id": "奥格雷"
  },
  "瓜纳华托": {
    "id": "瓜纳华托"
  },
  "塞卡卡": {
    "id": "塞卡卡"
  },
  "奥西耶克-巴拉尼亚": {
    "id": "奥西耶克-巴拉尼亚"
  },
  "锡尔河": {
    "id": "锡尔河"
  },
  "大西洋": {
    "id": "大西洋"
  },
  "久尔久": {
    "id": "久尔久"
  },
  "万福": {
    "id": "万福"
  },
  "直布罗陀": {
    "id": "直布罗陀"
  },
  "廊开": {
    "id": "廊开"
  },
  "赤塔": {
    "id": "赤塔"
  },
  "卡昂": {
    "id": "卡昂"
  },
  "瑟孔达": {
    "id": "瑟孔达"
  },
  "维良地": {
    "id": "维良地"
  },
  "伊拉普阿托": {
    "id": "伊拉普阿托"
  },
  "赖扬": {
    "id": "赖扬"
  },
  "格陵兰": {
    "id": "格陵兰"
  },
  "拉乌尼翁": {
    "id": "拉乌尼翁"
  },
  "塔拉戈纳": {
    "id": "塔拉戈纳"
  },
  "伯尔尼": {
    "id": "伯尔尼"
  },
  "都柏林": {
    "id": "都柏林"
  },
  "part5": {
    "id": "part5"
  },
  "阿拉斯加": {
    "id": "阿拉斯加"
  },
  "渥太华": {
    "id": "渥太华"
  },
  "万塔": {
    "id": "万塔"
  },
  "南尼兰杜": {
    "id": "南尼兰杜"
  },
  "阿马库罗三角洲": {
    "id": "阿马库罗三角洲"
  },
  "沙隆": {
    "id": "沙隆"
  },
  "达卡": {
    "id": "达卡"
  },
  "肯套": {
    "id": "肯套"
  },
  "哈瓦那": {
    "id": "哈瓦那"
  },
  "阿尔高": {
    "id": "阿尔高"
  },
  "柔佛": {
    "id": "柔佛"
  },
  "南邦达马": {
    "id": "南邦达马"
  },
  "霍罗格": {
    "id": "霍罗格"
  },
  "波图格萨": {
    "id": "波图格萨"
  },
  "谢法": {
    "id": "谢法"
  },
  "圣加仑": {
    "id": "圣加仑"
  },
  "图卢兹": {
    "id": "图卢兹"
  },
  "科特卡": {
    "id": "科特卡"
  },
  "安帕赖": {
    "id": "安帕赖"
  },
  "青海省": {
    "id": "青海省"
  },
  "达曼": {
    "id": "达曼"
  },
  "索罗提": {
    "id": "索罗提"
  },
  "乔卢特卡": {
    "id": "乔卢特卡"
  },
  "科克扬加克": {
    "id": "科克扬加克"
  },
  "南部区": {
    "id": "南部区"
  },
  "卡普恰盖": {
    "id": "卡普恰盖"
  },
  "兰德方丹": {
    "id": "兰德方丹"
  },
  "鲁昆吉里": {
    "id": "鲁昆吉里"
  },
  "卡塞尔": {
    "id": "卡塞尔"
  },
  "埃门": {
    "id": "埃门"
  },
  "西迪布济德": {
    "id": "西迪布济德"
  },
  "奥汉圭纳": {
    "id": "奥汉圭纳"
  },
  "埃尔津詹": {
    "id": "埃尔津詹"
  },
  "马莱塔": {
    "id": "马莱塔"
  },
  "奥希科托": {
    "id": "奥希科托"
  },
  "索波特": {
    "id": "索波特"
  },
  "萨尔瓦多": {
    "id": "萨尔瓦多"
  },
  "暹粒": {
    "id": "暹粒"
  },
  "卡嫩迪尤": {
    "id": "卡嫩迪尤"
  },
  "孔西": {
    "id": "孔西"
  },
  "大阪": {
    "id": "大阪"
  },
  "白俄罗斯": {
    "id": "白俄罗斯"
  },
  "冰岛": {
    "id": "冰岛"
  },
  "瓜达拉哈拉": {
    "id": "瓜达拉哈拉"
  },
  "别德马": {
    "id": "别德马"
  },
  "纽伦堡": {
    "id": "纽伦堡"
  },
  "蒂尔堡": {
    "id": "蒂尔堡"
  },
  "苏博蒂察": {
    "id": "苏博蒂察"
  },
  "埃塞俄比亚": {
    "id": "埃塞俄比亚"
  },
  "恩古涅": {
    "id": "恩古涅"
  },
  "爱兹克劳克雷": {
    "id": "爱兹克劳克雷"
  },
  "波坦察": {
    "id": "波坦察"
  },
  "基加利-恩加利": {
    "id": "基加利-恩加利"
  },
  "埃佩切": {
    "id": "埃佩切"
  },
  "锡诺普": {
    "id": "锡诺普"
  },
  "海门林纳": {
    "id": "海门林纳"
  },
  "尼科西亚": {
    "id": "尼科西亚"
  },
  "布宜诺斯艾利斯": {
    "id": "布宜诺斯艾利斯"
  },
  "阿拉伯联合酋长国": {
    "id": "阿拉伯联合酋长国"
  },
  "戈尔韦": {
    "id": "戈尔韦"
  },
  "奇南德加": {
    "id": "奇南德加"
  },
  "马尤岛": {
    "id": "马尤岛"
  },
  "印度": {
    "id": "印度"
  },
  "法鲁": {
    "id": "法鲁"
  },
  "热那亚": {
    "id": "热那亚"
  },
  "伊卜": {
    "id": "伊卜"
  },
  "洛桑": {
    "id": "洛桑"
  },
  "卡萨纳雷": {
    "id": "卡萨纳雷"
  },
  "丰沙尔": {
    "id": "丰沙尔"
  },
  "恩戈齐": {
    "id": "恩戈齐"
  },
  "奥乔宗蒂约巴": {
    "id": "奥乔宗蒂约巴"
  },
  "日托米尔": {
    "id": "日托米尔"
  },
  "塔什干市": {
    "id": "塔什干市"
  },
  "马泰拉": {
    "id": "马泰拉"
  },
  "海湾": {
    "id": "海湾"
  },
  "老挝": {
    "id": "老挝"
  },
  "巴拉那": {
    "id": "巴拉那"
  },
  "基特加": {
    "id": "基特加"
  },
  "东胡德": {
    "id": "东胡德"
  },
  "亚加": {
    "id": "亚加"
  },
  "阿鲁沙": {
    "id": "阿鲁沙"
  },
  "科尔多凡": {
    "id": "科尔多凡"
  },
  "埃利斯塔": {
    "id": "埃利斯塔"
  },
  "亭可马里": {
    "id": "亭可马里"
  },
  "西佛兰德": {
    "id": "西佛兰德"
  },
  "东京": {
    "id": "东京"
  },
  "伊卡": {
    "id": "伊卡"
  },
  "拉西锡": {
    "id": "拉西锡"
  },
  "霍姆斯": {
    "id": "霍姆斯"
  },
  "马拉维": {
    "id": "马拉维"
  },
  "科罗尼": {
    "id": "科罗尼"
  },
  "阿特兰蒂达": {
    "id": "阿特兰蒂达"
  },
  "勃固省": {
    "id": "勃固省"
  },
  "金边市": {
    "id": "金边市"
  },
  "博波卢": {
    "id": "博波卢"
  },
  "南日德兰": {
    "id": "南日德兰"
  },
  "兹沃勒": {
    "id": "兹沃勒"
  },
  "苏梅": {
    "id": "苏梅"
  },
  "part6": {
    "id": "part6"
  },
  "维多利亚": {
    "id": "维多利亚"
  },
  "维斯普雷姆": {
    "id": "维斯普雷姆"
  },
  "佐治亚": {
    "id": "佐治亚"
  },
  "沙拉湾": {
    "id": "沙拉湾"
  },
  "施蒂利亚": {
    "id": "施蒂利亚"
  },
  "叙利亚": {
    "id": "叙利亚"
  },
  "陕西省": {
    "id": "陕西省"
  },
  "乌姆锡拉勒": {
    "id": "乌姆锡拉勒"
  },
  "普热梅希尔": {
    "id": "普热梅希尔"
  },
  "特维尔": {
    "id": "特维尔"
  },
  "纽约": {
    "id": "纽约"
  },
  "拉普拉": {
    "id": "拉普拉"
  },
  "格但斯克": {
    "id": "格但斯克"
  },
  "杜布罗夫斯克-内雷特瓦": {
    "id": "杜布罗夫斯克-内雷特瓦"
  },
  "乌姆塔拉": {
    "id": "乌姆塔拉"
  },
  "圣彼得堡": {
    "id": "圣彼得堡"
  },
  "奥姆沙蒂": {
    "id": "奥姆沙蒂"
  },
  "锡尔万": {
    "id": "锡尔万"
  },
  "尼亚米拉": {
    "id": "尼亚米拉"
  },
  "巴里": {
    "id": "巴里"
  },
  "伊萨城": {
    "id": "伊萨城"
  },
  "雅西": {
    "id": "雅西"
  },
  "奥兰群岛": {
    "id": "奥兰群岛"
  },
  "卡塔马卡": {
    "id": "卡塔马卡"
  },
  "图尔卡纳": {
    "id": "图尔卡纳"
  },
  "泽尼察－多博伊": {
    "id": "泽尼察－多博伊"
  },
  "新德里": {
    "id": "新德里"
  },
  "奇瓦瓦": {
    "id": "奇瓦瓦"
  },
  "本地治里": {
    "id": "本地治里"
  },
  "高原": {
    "id": "高原"
  },
  "普沃茨克": {
    "id": "普沃茨克"
  },
  "上韦拉帕斯": {
    "id": "上韦拉帕斯"
  },
  "塔武什": {
    "id": "塔武什"
  },
  "阿斯特拉罕": {
    "id": "阿斯特拉罕"
  },
  "埃尔帕拉伊索": {
    "id": "埃尔帕拉伊索"
  },
  "贾夫纳": {
    "id": "贾夫纳"
  },
  "皮瓦": {
    "id": "皮瓦"
  },
  "埃尔布隆格": {
    "id": "埃尔布隆格"
  },
  "内比": {
    "id": "内比"
  },
  "怀俄明": {
    "id": "怀俄明"
  },
  "北帕默斯顿": {
    "id": "北帕默斯顿"
  },
  "科卢马杜卢": {
    "id": "科卢马杜卢"
  },
  "澳大利亚": {
    "id": "澳大利亚"
  },
  "威尔士": {
    "id": "威尔士"
  },
  "巴尔维": {
    "id": "巴尔维"
  },
  "戈雷尼": {
    "id": "戈雷尼"
  },
  "贝卡": {
    "id": "贝卡"
  },
  "爱媛": {
    "id": "爱媛"
  },
  "阿涅比": {
    "id": "阿涅比"
  },
  "卡塞塔": {
    "id": "卡塞塔"
  },
  "特伦钦": {
    "id": "特伦钦"
  },
  "锡尔萨瓦": {
    "id": "锡尔萨瓦"
  },
  "坦噶": {
    "id": "坦噶"
  },
  "巴克乌": {
    "id": "巴克乌"
  },
  "白马市": {
    "id": "白马市"
  },
  "科蒙加里": {
    "id": "科蒙加里"
  },
  "金奈": {
    "id": "金奈"
  },
  "昆士兰": {
    "id": "昆士兰"
  },
  "哈萨克斯坦": {
    "id": "哈萨克斯坦"
  },
  "天津市": {
    "id": "天津市"
  },
  "科克": {
    "id": "科克"
  },
  "东塞皮克": {
    "id": "东塞皮克"
  },
  "巴里纳斯": {
    "id": "巴里纳斯"
  },
  "江西省": {
    "id": "江西省"
  },
  "塞阿拉": {
    "id": "塞阿拉"
  },
  "提亚雷特": {
    "id": "提亚雷特"
  },
  "阿尔瓦塞特": {
    "id": "阿尔瓦塞特"
  },
  "比得哥什": {
    "id": "比得哥什"
  },
  "百慕大": {
    "id": "百慕大"
  },
  "圣斯皮里图斯": {
    "id": "圣斯皮里图斯"
  },
  "纳伦": {
    "id": "纳伦"
  },
  "阿帕克": {
    "id": "阿帕克"
  },
  "梅奥": {
    "id": "梅奥"
  },
  "姆万扎": {
    "id": "姆万扎"
  },
  "塞维利亚": {
    "id": "塞维利亚"
  },
  "卡拉斯": {
    "id": "卡拉斯"
  },
  "马斯喀特省": {
    "id": "马斯喀特省"
  },
  "尼尔斯特隆": {
    "id": "尼尔斯特隆"
  },
  "圣拉斐尔": {
    "id": "圣拉斐尔"
  },
  "莱恩群岛": {
    "id": "莱恩群岛"
  },
  "哈拉雷": {
    "id": "哈拉雷"
  },
  "波萨里卡": {
    "id": "波萨里卡"
  },
  "波里坎赛": {
    "id": "波里坎赛"
  },
  "中卡瓦利": {
    "id": "中卡瓦利"
  },
  "拜伊罗特": {
    "id": "拜伊罗特"
  },
  "南马托格罗索": {
    "id": "南马托格罗索"
  },
  "乌布里滕加": {
    "id": "乌布里滕加"
  },
  "南米拉杜马杜卢": {
    "id": "南米拉杜马杜卢"
  },
  "北部地区": {
    "id": "北部地区"
  },
  "班迭棉吉": {
    "id": "班迭棉吉"
  },
  "不丹": {
    "id": "不丹"
  },
  "什未林": {
    "id": "什未林"
  },
  "罗马": {
    "id": "罗马"
  },
  "阿尔巴尼亚": {
    "id": "阿尔巴尼亚"
  },
  "梅吉穆列": {
    "id": "梅吉穆列"
  },
  "穆因加": {
    "id": "穆因加"
  },
  "非斯": {
    "id": "非斯"
  },
  "卡尼略": {
    "id": "卡尼略"
  },
  "特拉布宗": {
    "id": "特拉布宗"
  },
  "阿克什胡斯": {
    "id": "阿克什胡斯"
  },
  "马约特岛": {
    "id": "马约特岛"
  },
  "part7": {
    "id": "part7"
  },
  "爱尔巴桑": {
    "id": "爱尔巴桑"
  },
  "利基卡": {
    "id": "利基卡"
  },
  "巴林": {
    "id": "巴林"
  },
  "乌苏卢坦": {
    "id": "乌苏卢坦"
  },
  "首尔": {
    "id": "首尔"
  },
  "玻璃市": {
    "id": "玻璃市"
  },
  "北远": {
    "id": "北远"
  },
  "延布": {
    "id": "延布"
  },
  "阿伊纳罗": {
    "id": "阿伊纳罗"
  },
  "河北省": {
    "id": "河北省"
  },
  "基切": {
    "id": "基切"
  },
  "阿法尔": {
    "id": "阿法尔"
  },
  "贝尔谢巴": {
    "id": "贝尔谢巴"
  },
  "海法": {
    "id": "海法"
  },
  "瑞士": {
    "id": "瑞士"
  },
  "努沃勒埃利耶": {
    "id": "努沃勒埃利耶"
  },
  "西波克特": {
    "id": "西波克特"
  },
  "波斯尼亚和黑塞哥维那": {
    "id": "波斯尼亚和黑塞哥维那"
  },
  "布鲁塞尔": {
    "id": "布鲁塞尔"
  },
  "瓦乌布日赫": {
    "id": "瓦乌布日赫"
  },
  "静冈": {
    "id": "静冈"
  },
  "北博滕": {
    "id": "北博滕"
  },
  "利萨科夫斯克": {
    "id": "利萨科夫斯克"
  },
  "索非亚市": {
    "id": "索非亚市"
  },
  "新义州": {
    "id": "新义州"
  },
  "德阿尔": {
    "id": "德阿尔"
  },
  "萨莱诺": {
    "id": "萨莱诺"
  },
  "加贝斯": {
    "id": "加贝斯"
  },
  "阿曼拜": {
    "id": "阿曼拜"
  },
  "内罗毕": {
    "id": "内罗毕"
  },
  "伊拉克": {
    "id": "伊拉克"
  },
  "奥尔比亚": {
    "id": "奥尔比亚"
  },
  "博托沙尼": {
    "id": "博托沙尼"
  },
  "巴杰": {
    "id": "巴杰"
  },
  "瑙鲁": {
    "id": "瑙鲁"
  },
  "斯德哥尔摩": {
    "id": "斯德哥尔摩"
  },
  "布巴内斯瓦尔": {
    "id": "布巴内斯瓦尔"
  },
  "吉扎克": {
    "id": "吉扎克"
  },
  "阿纳": {
    "id": "阿纳"
  },
  "福克沙尼": {
    "id": "福克沙尼"
  },
  "卡拉奇": {
    "id": "卡拉奇"
  },
  "比塞大": {
    "id": "比塞大"
  },
  "扎波罗热": {
    "id": "扎波罗热"
  },
  "和歌山": {
    "id": "和歌山"
  },
  "拉巴特": {
    "id": "拉巴特"
  },
  "泰莫图": {
    "id": "泰莫图"
  },
  "马安": {
    "id": "马安"
  },
  "克拉斯诺达尔": {
    "id": "克拉斯诺达尔"
  },
  "科马罗姆": {
    "id": "科马罗姆"
  },
  "维泰博": {
    "id": "维泰博"
  },
  "巴蜀": {
    "id": "巴蜀"
  },
  "圣米格尔-德图库曼": {
    "id": "圣米格尔-德图库曼"
  },
  "中部群岛": {
    "id": "中部群岛"
  },
  "南戈壁": {
    "id": "南戈壁"
  },
  "橘园": {
    "id": "橘园"
  },
  "波尔图": {
    "id": "波尔图"
  },
  "尼泊尔": {
    "id": "尼泊尔"
  },
  "佐法尔省": {
    "id": "佐法尔省"
  },
  "辛吉达": {
    "id": "辛吉达"
  },
  "菲亚纳兰楚阿": {
    "id": "菲亚纳兰楚阿"
  },
  "孟邦": {
    "id": "孟邦"
  },
  "维尔京群岛，英属": {
    "id": "维尔京群岛，英属"
  },
  "萨拉戈萨": {
    "id": "萨拉戈萨"
  },
  "布朗阿哈福": {
    "id": "布朗阿哈福"
  },
  "马加斯": {
    "id": "马加斯"
  },
  "沃": {
    "id": "沃"
  },
  "鲁伍马": {
    "id": "鲁伍马"
  },
  "阿黎博里": {
    "id": "阿黎博里"
  },
  "乌得勒支": {
    "id": "乌得勒支"
  },
  "桑给巴尔南": {
    "id": "桑给巴尔南"
  },
  "锡拉库扎": {
    "id": "锡拉库扎"
  },
  "恰纳卡莱": {
    "id": "恰纳卡莱"
  },
  "乌卡亚利": {
    "id": "乌卡亚利"
  },
  "维罗维蒂察-波德拉维纳": {
    "id": "维罗维蒂察-波德拉维纳"
  },
  "捷斯": {
    "id": "捷斯"
  },
  "斯洛博齐亚": {
    "id": "斯洛博齐亚"
  },
  "亚齐": {
    "id": "亚齐"
  },
  "戈尔诺－阿尔泰斯克": {
    "id": "戈尔诺－阿尔泰斯克"
  },
  "帕德尔": {
    "id": "帕德尔"
  },
  "乌埃": {
    "id": "乌埃"
  },
  "库洛布": {
    "id": "库洛布"
  },
  "梁赞": {
    "id": "梁赞"
  },
  "阿肯色": {
    "id": "阿肯色"
  },
  "阿劳卡": {
    "id": "阿劳卡"
  },
  "霍茹夫": {
    "id": "霍茹夫"
  },
  "吉森": {
    "id": "吉森"
  },
  "翁贝拉-姆波科": {
    "id": "翁贝拉-姆波科"
  },
  "中科莫埃": {
    "id": "中科莫埃"
  },
  "忠清南道": {
    "id": "忠清南道"
  },
  "姆巴莱": {
    "id": "姆巴莱"
  },
  "杜罗": {
    "id": "杜罗"
  },
  "努奥罗": {
    "id": "努奥罗"
  },
  "顿河畔罗斯托夫": {
    "id": "顿河畔罗斯托夫"
  },
  "桑给巴尔北": {
    "id": "桑给巴尔北"
  },
  "罗斯康芒": {
    "id": "罗斯康芒"
  },
  "阿根廷": {
    "id": "阿根廷"
  },
  "委内瑞拉": {
    "id": "委内瑞拉"
  },
  "科赫德斯": {
    "id": "科赫德斯"
  },
  "卡罗维发利": {
    "id": "卡罗维发利"
  },
  "哈派": {
    "id": "哈派"
  },
  "鲁德内": {
    "id": "鲁德内"
  },
  "程逸": {
    "id": "程逸"
  },
  "纳季兰": {
    "id": "纳季兰"
  },
  "part8": {
    "id": "part8"
  },
  "波多诺伏": {
    "id": "波多诺伏"
  },
  "勒姆尼库沃尔恰": {
    "id": "勒姆尼库沃尔恰"
  },
  "蒙古": {
    "id": "蒙古"
  },
  "东帝汶": {
    "id": "东帝汶"
  },
  "因巴布拉": {
    "id": "因巴布拉"
  },
  "基西": {
    "id": "基西"
  },
  "意大利": {
    "id": "意大利"
  },
  "阿塔卡马大区": {
    "id": "阿塔卡马大区"
  },
  "苏格兰": {
    "id": "苏格兰"
  },
  "上巴拉那": {
    "id": "上巴拉那"
  },
  "桔井": {
    "id": "桔井"
  },
  "格罗宁根": {
    "id": "格罗宁根"
  },
  "坦皮科": {
    "id": "坦皮科"
  },
  "通古拉瓦": {
    "id": "通古拉瓦"
  },
  "罕西拉": {
    "id": "罕西拉"
  },
  "江布尔": {
    "id": "江布尔"
  },
  "穆翁": {
    "id": "穆翁"
  },
  "阿斯蒂": {
    "id": "阿斯蒂"
  },
  "维尔京群岛，美属": {
    "id": "维尔京群岛，美属"
  },
  "安哥拉": {
    "id": "安哥拉"
  },
  "蒙特雷": {
    "id": "蒙特雷"
  },
  "东佛兰德": {
    "id": "东佛兰德"
  },
  "河南省": {
    "id": "河南省"
  },
  "马纳尔": {
    "id": "马纳尔"
  },
  "东伦敦": {
    "id": "东伦敦"
  },
  "比利亚埃尔莫萨": {
    "id": "比利亚埃尔莫萨"
  },
  "布依拉": {
    "id": "布依拉"
  },
  "安塞巴": {
    "id": "安塞巴"
  },
  "山梨": {
    "id": "山梨"
  },
  "布罗德-波萨维纳": {
    "id": "布罗德-波萨维纳"
  },
  "亚马孙": {
    "id": "亚马孙"
  },
  "西迪贝勒阿贝斯": {
    "id": "西迪贝勒阿贝斯"
  },
  "亚厉山德里亚": {
    "id": "亚厉山德里亚"
  },
  "石川": {
    "id": "石川"
  },
  "克里米亚自治共和国": {
    "id": "克里米亚自治共和国"
  },
  "包考": {
    "id": "包考"
  },
  "马里扬泊列": {
    "id": "马里扬泊列"
  },
  "布罗科蓬多": {
    "id": "布罗科蓬多"
  },
  "安塔利亚": {
    "id": "安塔利亚"
  },
  "雷焦卡拉布里亚": {
    "id": "雷焦卡拉布里亚"
  },
  "捷尔诺波尔": {
    "id": "捷尔诺波尔"
  },
  "日利纳": {
    "id": "日利纳"
  },
  "奥斯雷德涅斯洛文": {
    "id": "奥斯雷德涅斯洛文"
  },
  "卡萨布兰卡": {
    "id": "卡萨布兰卡"
  },
  "安纳乍能": {
    "id": "安纳乍能"
  },
  "萨桑德拉": {
    "id": "萨桑德拉"
  },
  "约什卡尔奥拉": {
    "id": "约什卡尔奥拉"
  },
  "吉塞尼": {
    "id": "吉塞尼"
  },
  "佩鲁贾": {
    "id": "佩鲁贾"
  },
  "荷属安地列斯": {
    "id": "荷属安地列斯"
  },
  "素林": {
    "id": "素林"
  },
  "伊拉克里翁": {
    "id": "伊拉克里翁"
  },
  "吕讷堡": {
    "id": "吕讷堡"
  },
  "卡塞塞": {
    "id": "卡塞塞"
  },
  "挪威": {
    "id": "挪威"
  },
  "纳沙泰尔": {
    "id": "纳沙泰尔"
  },
  "伊斯坦布尔": {
    "id": "伊斯坦布尔"
  },
  "奥胡斯": {
    "id": "奥胡斯"
  },
  "马来西亚": {
    "id": "马来西亚"
  },
  "谢戈德阿维拉": {
    "id": "谢戈德阿维拉"
  },
  "卡拉库尔": {
    "id": "卡拉库尔"
  },
  "阿默斯福特": {
    "id": "阿默斯福特"
  },
  "奥斯陆市": {
    "id": "奥斯陆市"
  },
  "万卡维利卡": {
    "id": "万卡维利卡"
  },
  "亚拉奎": {
    "id": "亚拉奎"
  },
  "卡诺": {
    "id": "卡诺"
  },
  "塔纳河": {
    "id": "塔纳河"
  },
  "披集": {
    "id": "披集"
  },
  "日内瓦": {
    "id": "日内瓦"
  },
  "亚历山德里亚": {
    "id": "亚历山德里亚"
  },
  "魁北克": {
    "id": "魁北克"
  },
  "乌兹别克斯坦": {
    "id": "乌兹别克斯坦"
  },
  "贝尼": {
    "id": "贝尼"
  },
  "三十三人": {
    "id": "三十三人"
  },
  "乌伦迪": {
    "id": "乌伦迪"
  },
  "恩坎普": {
    "id": "恩坎普"
  },
  "江苏省": {
    "id": "江苏省"
  },
  "霍达兰": {
    "id": "霍达兰"
  },
  "玛木": {
    "id": "玛木"
  },
  "腊塔纳基里": {
    "id": "腊塔纳基里"
  },
  "阿什哈巴德市": {
    "id": "阿什哈巴德市"
  },
  "马坦萨斯": {
    "id": "马坦萨斯"
  },
  "达尔富尔": {
    "id": "达尔富尔"
  },
  "达尔汗乌勒": {
    "id": "达尔汗乌勒"
  },
  "西恩富戈斯": {
    "id": "西恩富戈斯"
  },
  "科尔特斯": {
    "id": "科尔特斯"
  },
  "纳卡松戈拉": {
    "id": "纳卡松戈拉"
  },
  "塔克纳": {
    "id": "塔克纳"
  },
  "穆尔西亚": {
    "id": "穆尔西亚"
  },
  "派桑杜": {
    "id": "派桑杜"
  },
  "乌隆": {
    "id": "乌隆"
  },
  "特里尔": {
    "id": "特里尔"
  },
  "part9": {
    "id": "part9"
  },
  "巴提奈地区": {
    "id": "巴提奈地区"
  },
  "阿拉木图": {
    "id": "阿拉木图"
  },
  "屈塔希亚": {
    "id": "屈塔希亚"
  },
  "瓦斯卢伊": {
    "id": "瓦斯卢伊"
  },
  "希维诺乌伊希切": {
    "id": "希维诺乌伊希切"
  },
  "乌多姆赛": {
    "id": "乌多姆赛"
  },
  "耶路撒冷": {
    "id": "耶路撒冷"
  },
  "托莱多": {
    "id": "托莱多"
  },
  "秋田": {
    "id": "秋田"
  },
  "库福": {
    "id": "库福"
  },
  "罗兹": {
    "id": "罗兹"
  },
  "法属圭亚那": {
    "id": "法属圭亚那"
  },
  "基尔": {
    "id": "基尔"
  },
  "科沙林": {
    "id": "科沙林"
  },
  "马德望": {
    "id": "马德望"
  },
  "厄立特里亚": {
    "id": "厄立特里亚"
  },
  "伊洛潘戈": {
    "id": "伊洛潘戈"
  },
  "博洛尼亚": {
    "id": "博洛尼亚"
  },
  "圣路易": {
    "id": "圣路易"
  },
  "突尼斯": {
    "id": "突尼斯"
  },
  "孔敬": {
    "id": "孔敬"
  },
  "卡亚尼": {
    "id": "卡亚尼"
  },
  "约旦": {
    "id": "约旦"
  },
  "马累岛": {
    "id": "马累岛"
  },
  "甘达基": {
    "id": "甘达基"
  },
  "巴西": {
    "id": "巴西"
  },
  "卡克塔": {
    "id": "卡克塔"
  },
  "邦": {
    "id": "邦"
  },
  "里瓦斯": {
    "id": "里瓦斯"
  },
  "加拉帕戈斯": {
    "id": "加拉帕戈斯"
  },
  "埃雷迪亚": {
    "id": "埃雷迪亚"
  },
  "南部": {
    "id": "南部"
  },
  "南隆达": {
    "id": "南隆达"
  },
  "鲁塔纳": {
    "id": "鲁塔纳"
  },
  "伊利诺斯": {
    "id": "伊利诺斯"
  },
  "基洛夫": {
    "id": "基洛夫"
  },
  "孔皮恩加": {
    "id": "孔皮恩加"
  },
  "西哈努克市": {
    "id": "西哈努克市"
  },
  "比亚维斯托克": {
    "id": "比亚维斯托克"
  },
  "谢德尔采": {
    "id": "谢德尔采"
  },
  "伯南布哥": {
    "id": "伯南布哥"
  },
  "马里卜": {
    "id": "马里卜"
  },
  "锡耶纳": {
    "id": "锡耶纳"
  },
  "凯里乔": {
    "id": "凯里乔"
  },
  "美国": {
    "id": "美国"
  },
  "博乔": {
    "id": "博乔"
  },
  "加姆珀哈": {
    "id": "加姆珀哈"
  },
  "布干维尔": {
    "id": "布干维尔"
  },
  "瓦卡": {
    "id": "瓦卡"
  },
  "锡比乌": {
    "id": "锡比乌"
  },
  "卡卡梅加": {
    "id": "卡卡梅加"
  },
  "多索": {
    "id": "多索"
  },
  "利拉": {
    "id": "利拉"
  },
  "昆卡": {
    "id": "昆卡"
  },
  "罗瓦涅米": {
    "id": "罗瓦涅米"
  },
  "马斯温戈": {
    "id": "马斯温戈"
  },
  "马塔姆": {
    "id": "马塔姆"
  },
  "曼格斯套": {
    "id": "曼格斯套"
  },
  "马尔多纳多": {
    "id": "马尔多纳多"
  },
  "鲁达": {
    "id": "鲁达"
  },
  "马塔加尔帕": {
    "id": "马塔加尔帕"
  },
  "孟加拉": {
    "id": "孟加拉"
  },
  "米德尔堡": {
    "id": "米德尔堡"
  },
  "诺维萨德": {
    "id": "诺维萨德"
  },
  "阿耶斯总统省": {
    "id": "阿耶斯总统省"
  },
  "卡利亚里": {
    "id": "卡利亚里"
  },
  "卡尼亚尔": {
    "id": "卡尼亚尔"
  },
  "仰光省": {
    "id": "仰光省"
  },
  "桑坦德": {
    "id": "桑坦德"
  },
  "哈密尔顿": {
    "id": "哈密尔顿"
  },
  "毛里求斯": {
    "id": "毛里求斯"
  },
  "古廷": {
    "id": "古廷"
  },
  "汝拉": {
    "id": "汝拉"
  },
  "亚喀巴": {
    "id": "亚喀巴"
  },
  "开塞利": {
    "id": "开塞利"
  },
  "贝贾亚": {
    "id": "贝贾亚"
  },
  "里约热内卢": {
    "id": "里约热内卢"
  },
  "佩滕": {
    "id": "佩滕"
  },
  "卡扎赫": {
    "id": "卡扎赫"
  },
  "黎巴嫩": {
    "id": "黎巴嫩"
  },
  "普诺": {
    "id": "普诺"
  },
  "北马里亚纳群岛": {
    "id": "北马里亚纳群岛"
  },
  "塔奇拉": {
    "id": "塔奇拉"
  },
  "埃拉泽": {
    "id": "埃拉泽"
  },
  "莫洛戈罗": {
    "id": "莫洛戈罗"
  },
  "马拉加": {
    "id": "马拉加"
  },
  "佛丕": {
    "id": "佛丕"
  },
  "弗雷德里顿": {
    "id": "弗雷德里顿"
  },
  "澳门特别行政区": {
    "id": "澳门特别行政区"
  },
  "艾藻尔": {
    "id": "艾藻尔"
  },
  "图尔恰": {
    "id": "图尔恰"
  },
  "切哈努夫": {
    "id": "切哈努夫"
  },
  "布吉里": {
    "id": "布吉里"
  },
  "阿尔阿尔": {
    "id": "阿尔阿尔"
  },
  "杰里扬拜特奈": {
    "id": "杰里扬拜特奈"
  },
  "瓦吉尔": {
    "id": "瓦吉尔"
  },
  "雷希察": {
    "id": "雷希察"
  },
  "马坎巴": {
    "id": "马坎巴"
  },
  "科威特": {
    "id": "科威特"
  },
  "南苏门答腊": {
    "id": "南苏门答腊"
  },
  "伊德利卜": {
    "id": "伊德利卜"
  },
  "威斯巴登": {
    "id": "威斯巴登"
  },
  "里尔": {
    "id": "里尔"
  },
  "part10": {
    "id": "part10"
  },
  "基安布": {
    "id": "基安布"
  },
  "雷诺萨": {
    "id": "雷诺萨"
  },
  "圭亚那": {
    "id": "圭亚那"
  },
  "斋普尔": {
    "id": "斋普尔"
  },
  "新泽西": {
    "id": "新泽西"
  },
  "宋卡": {
    "id": "宋卡"
  },
  "廷杜夫": {
    "id": "廷杜夫"
  },
  "雷泽克内": {
    "id": "雷泽克内"
  },
  "伊斯兰堡": {
    "id": "伊斯兰堡"
  },
  "阿克里": {
    "id": "阿克里"
  },
  "基里诺奇": {
    "id": "基里诺奇"
  },
  "斯威士兰": {
    "id": "斯威士兰"
  },
  "亚松森特别区": {
    "id": "亚松森特别区"
  },
  "布利达": {
    "id": "布利达"
  },
  "乌鲁阿潘": {
    "id": "乌鲁阿潘"
  },
  "盖尔马": {
    "id": "盖尔马"
  },
  "绍莫吉": {
    "id": "绍莫吉"
  },
  "马雷": {
    "id": "马雷"
  },
  "法属波利尼西亚": {
    "id": "法属波利尼西亚"
  },
  "基埃-恩特姆": {
    "id": "基埃-恩特姆"
  },
  "柴桢": {
    "id": "柴桢"
  },
  "利巴特茹": {
    "id": "利巴特茹"
  },
  "纳拉亚尼": {
    "id": "纳拉亚尼"
  },
  "拉飞": {
    "id": "拉飞"
  },
  "夜功": {
    "id": "夜功"
  },
  "因希里": {
    "id": "因希里"
  },
  "开城": {
    "id": "开城"
  },
  "布达佩斯": {
    "id": "布达佩斯"
  },
  "莱昂": {
    "id": "莱昂"
  },
  "廊莫那浦": {
    "id": "廊莫那浦"
  },
  "北里奥格兰德": {
    "id": "北里奥格兰德"
  },
  "吉大港": {
    "id": "吉大港"
  },
  "中非共和国": {
    "id": "中非共和国"
  },
  "蒂斯姆西勒特": {
    "id": "蒂斯姆西勒特"
  },
  "诺瓦拉": {
    "id": "诺瓦拉"
  },
  "清津": {
    "id": "清津"
  },
  "切博克萨雷": {
    "id": "切博克萨雷"
  },
  "霍尼亚拉": {
    "id": "霍尼亚拉"
  },
  "利雅得": {
    "id": "利雅得"
  },
  "库内内": {
    "id": "库内内"
  },
  "塔曼拉塞特": {
    "id": "塔曼拉塞特"
  },
  "格林纳达": {
    "id": "格林纳达"
  },
  "姆库泽": {
    "id": "姆库泽"
  },
  "库米": {
    "id": "库米"
  },
  "钦查阿尔塔": {
    "id": "钦查阿尔塔"
  },
  "马尔代夫": {
    "id": "马尔代夫"
  },
  "瓜亚斯": {
    "id": "瓜亚斯"
  },
  "布哈拉": {
    "id": "布哈拉"
  },
  "东努沙登加拉": {
    "id": "东努沙登加拉"
  },
  "加蓬": {
    "id": "加蓬"
  },
  "基加利市": {
    "id": "基加利市"
  },
  "坦波夫": {
    "id": "坦波夫"
  },
  "江界": {
    "id": "江界"
  },
  "法尔孔": {
    "id": "法尔孔"
  },
  "韦尔瓦": {
    "id": "韦尔瓦"
  },
  "瓦萨": {
    "id": "瓦萨"
  },
  "瓦姆-彭代": {
    "id": "瓦姆-彭代"
  },
  "阿朱马尼": {
    "id": "阿朱马尼"
  },
  "帕索雷": {
    "id": "帕索雷"
  },
  "圣多美和普林西比": {
    "id": "圣多美和普林西比"
  },
  "哈杰": {
    "id": "哈杰"
  },
  "尼扬加": {
    "id": "尼扬加"
  },
  "桑马": {
    "id": "桑马"
  },
  "爱尔兰": {
    "id": "爱尔兰"
  },
  "塔拉帕卡大区": {
    "id": "塔拉帕卡大区"
  },
  "库奈特拉": {
    "id": "库奈特拉"
  },
  "苏里南": {
    "id": "苏里南"
  },
  "卡尔洛瓦茨": {
    "id": "卡尔洛瓦茨"
  },
  "南特": {
    "id": "南特"
  },
  "南马塔贝莱兰": {
    "id": "南马塔贝莱兰"
  },
  "马尼萨": {
    "id": "马尼萨"
  },
  "马绍尔群岛": {
    "id": "马绍尔群岛"
  },
  "卡尔奇": {
    "id": "卡尔奇"
  },
  "沃勒-恩特姆": {
    "id": "沃勒-恩特姆"
  },
  "波穆尔": {
    "id": "波穆尔"
  },
  "卡范": {
    "id": "卡范"
  },
  "尼日利亚": {
    "id": "尼日利亚"
  },
  "达姆施塔特": {
    "id": "达姆施塔特"
  },
  "连科兰": {
    "id": "连科兰"
  },
  "布泽乌": {
    "id": "布泽乌"
  },
  "仁川": {
    "id": "仁川"
  },
  "维鲁": {
    "id": "维鲁"
  },
  "克孜勒": {
    "id": "克孜勒"
  },
  "锡卡索": {
    "id": "锡卡索"
  },
  "拉纳尔和贝罗纳": {
    "id": "拉纳尔和贝罗纳"
  },
  "理查兹湾": {
    "id": "理查兹湾"
  },
  "夏威夷": {
    "id": "夏威夷"
  },
  "北揽": {
    "id": "北揽"
  },
  "济罗": {
    "id": "济罗"
  },
  "塞萨尔": {
    "id": "塞萨尔"
  },
  "巴特肯": {
    "id": "巴特肯"
  },
  "马埃": {
    "id": "马埃"
  },
  "北红海": {
    "id": "北红海"
  },
  "多贝莱": {
    "id": "多贝莱"
  },
  "穆甘-萨连": {
    "id": "穆甘-萨连"
  },
  "沃伦": {
    "id": "沃伦"
  },
  "海耶": {
    "id": "海耶"
  },
  "昆迪纳马卡": {
    "id": "昆迪纳马卡"
  },
  "part11": {
    "id": "part11"
  },
  "图库马": {
    "id": "图库马"
  },
  "君士坦丁": {
    "id": "君士坦丁"
  },
  "米克斯科": {
    "id": "米克斯科"
  },
  "暖武里": {
    "id": "暖武里"
  },
  "干尼亚": {
    "id": "干尼亚"
  },
  "新拉雷多": {
    "id": "新拉雷多"
  },
  "德林达依省": {
    "id": "德林达依省"
  },
  "沃尔特": {
    "id": "沃尔特"
  },
  "日惹特区": {
    "id": "日惹特区"
  },
  "博达伦": {
    "id": "博达伦"
  },
  "格拉纳达": {
    "id": "格拉纳达"
  },
  "永贝": {
    "id": "永贝"
  },
  "内皮尔": {
    "id": "内皮尔"
  },
  "红统": {
    "id": "红统"
  },
  "难": {
    "id": "难"
  },
  "都灵": {
    "id": "都灵"
  },
  "达累斯萨拉姆": {
    "id": "达累斯萨拉姆"
  },
  "南大西洋": {
    "id": "南大西洋"
  },
  "瓦尼卡": {
    "id": "瓦尼卡"
  },
  "桑道恩": {
    "id": "桑道恩"
  },
  "里韦拉": {
    "id": "里韦拉"
  },
  "松索纳特": {
    "id": "松索纳特"
  },
  "黎": {
    "id": "黎"
  },
  "黑塞哥维那－涅雷特瓦": {
    "id": "黑塞哥维那－涅雷特瓦"
  },
  "吉杰尔": {
    "id": "吉杰尔"
  },
  "卡农古": {
    "id": "卡农古"
  },
  "哈勒姆": {
    "id": "哈勒姆"
  },
  "乌纳－萨纳": {
    "id": "乌纳－萨纳"
  },
  "科连特斯": {
    "id": "科连特斯"
  },
  "乌拉圭": {
    "id": "乌拉圭"
  },
  "马里兰": {
    "id": "马里兰"
  },
  "科科拉": {
    "id": "科科拉"
  },
  "卡永加": {
    "id": "卡永加"
  },
  "纽阿斯": {
    "id": "纽阿斯"
  },
  "列巴普": {
    "id": "列巴普"
  },
  "大克鲁": {
    "id": "大克鲁"
  },
  "苏塞": {
    "id": "苏塞"
  },
  "斯莱戈": {
    "id": "斯莱戈"
  },
  "利沃夫": {
    "id": "利沃夫"
  },
  "上阿连特茹": {
    "id": "上阿连特茹"
  },
  "西部区": {
    "id": "西部区"
  },
  "吉诺卡斯特": {
    "id": "吉诺卡斯特"
  },
  "拉普拉塔": {
    "id": "拉普拉塔"
  },
  "奔巴北": {
    "id": "奔巴北"
  },
  "罗先": {
    "id": "罗先"
  },
  "南方各族": {
    "id": "南方各族"
  },
  "萨尔托": {
    "id": "萨尔托"
  },
  "拉巴斯": {
    "id": "拉巴斯"
  },
  "哈卡里": {
    "id": "哈卡里"
  },
  "山谷": {
    "id": "山谷"
  },
  "卡拉比克": {
    "id": "卡拉比克"
  },
  "坚杜拜": {
    "id": "坚杜拜"
  },
  "恩延扎": {
    "id": "恩延扎"
  },
  "下伏日": {
    "id": "下伏日"
  },
  "巴勒斯坦": {
    "id": "巴勒斯坦"
  },
  "阿雷斯": {
    "id": "阿雷斯"
  },
  "哈恩": {
    "id": "哈恩"
  },
  "卡斯塔莫努": {
    "id": "卡斯塔莫努"
  },
  "耶盖瓦": {
    "id": "耶盖瓦"
  },
  "阿珀尔多伦": {
    "id": "阿珀尔多伦"
  },
  "宾夕法尼亚": {
    "id": "宾夕法尼亚"
  },
  "车里雅宾斯克": {
    "id": "车里雅宾斯克"
  },
  "费耶尔": {
    "id": "费耶尔"
  },
  "梅吉": {
    "id": "梅吉"
  },
  "奔巴南": {
    "id": "奔巴南"
  },
  "门多萨": {
    "id": "门多萨"
  },
  "阿拉巴马": {
    "id": "阿拉巴马"
  },
  "温哥华": {
    "id": "温哥华"
  },
  "加拉信": {
    "id": "加拉信"
  },
  "伊斯法拉": {
    "id": "伊斯法拉"
  },
  "图兹拉－波德里涅": {
    "id": "图兹拉－波德里涅"
  },
  "特拉斯卡拉": {
    "id": "特拉斯卡拉"
  },
  "地拉那": {
    "id": "地拉那"
  },
  "吉河": {
    "id": "吉河"
  },
  "槟榔屿": {
    "id": "槟榔屿"
  },
  "北爱尔兰": {
    "id": "北爱尔兰"
  },
  "刚果民主共和国": {
    "id": "刚果民主共和国"
  },
  "蔚山": {
    "id": "蔚山"
  },
  "马基拉": {
    "id": "马基拉"
  },
  "马兰热": {
    "id": "马兰热"
  },
  "科尼亚": {
    "id": "科尼亚"
  },
  "马格德堡": {
    "id": "马格德堡"
  },
  "滨海区": {
    "id": "滨海区"
  },
  "彼尔姆": {
    "id": "彼尔姆"
  },
  "下瓦尔登": {
    "id": "下瓦尔登"
  },
  "加济安泰普": {
    "id": "加济安泰普"
  },
  "瓦莱": {
    "id": "瓦莱"
  },
  "斯洛文尼亚": {
    "id": "斯洛文尼亚"
  },
  "乌斯季": {
    "id": "乌斯季"
  },
  "第戎": {
    "id": "第戎"
  },
  "阿克莫拉": {
    "id": "阿克莫拉"
  },
  "拉纳卡": {
    "id": "拉纳卡"
  },
  "萨维尼": {
    "id": "萨维尼"
  },
  "苏丹": {
    "id": "苏丹"
  },
  "塔帕丘拉": {
    "id": "塔帕丘拉"
  },
  "堪萨斯": {
    "id": "堪萨斯"
  },
  "开普敦": {
    "id": "开普敦"
  },
  "科宁": {
    "id": "科宁"
  },
  "卡普里维": {
    "id": "卡普里维"
  },
  "part12": {
    "id": "part12"
  },
  "多米尼加共和国": {
    "id": "多米尼加共和国"
  },
  "北哈萨克斯坦": {
    "id": "北哈萨克斯坦"
  },
  "马格达雷那": {
    "id": "马格达雷那"
  },
  "沙缴": {
    "id": "沙缴"
  },
  "西澳大利亚": {
    "id": "西澳大利亚"
  },
  "春蓬": {
    "id": "春蓬"
  },
  "南科莫埃": {
    "id": "南科莫埃"
  },
  "纳亚拉": {
    "id": "纳亚拉"
  },
  "塔尔西": {
    "id": "塔尔西"
  },
  "哥印拜陀": {
    "id": "哥印拜陀"
  },
  "阿哈尔": {
    "id": "阿哈尔"
  },
  "格丁尼亚": {
    "id": "格丁尼亚"
  },
  "海德拉巴": {
    "id": "海德拉巴"
  },
  "比奥比奥大区": {
    "id": "比奥比奥大区"
  },
  "玛哈沙拉堪": {
    "id": "玛哈沙拉堪"
  },
  "俄亥俄": {
    "id": "俄亥俄"
  },
  "瓜达尔卡纳尔": {
    "id": "瓜达尔卡纳尔"
  },
  "瓜里科": {
    "id": "瓜里科"
  },
  "萨格勒布": {
    "id": "萨格勒布"
  },
  "伊热夫斯克": {
    "id": "伊热夫斯克"
  },
  "本格拉": {
    "id": "本格拉"
  },
  "克赖斯特彻奇": {
    "id": "克赖斯特彻奇"
  },
  "林迪": {
    "id": "林迪"
  },
  "帕尔努": {
    "id": "帕尔努"
  },
  "梅里达": {
    "id": "梅里达"
  },
  "磅同": {
    "id": "磅同"
  },
  "穆瓦洛": {
    "id": "穆瓦洛"
  },
  "新加坡": {
    "id": "新加坡"
  },
  "卡兰加拉": {
    "id": "卡兰加拉"
  },
  "德瓦": {
    "id": "德瓦"
  },
  "特贝萨": {
    "id": "特贝萨"
  },
  "莫斯特罗": {
    "id": "莫斯特罗"
  },
  "博茨瓦纳": {
    "id": "博茨瓦纳"
  },
  "乔治亚": {
    "id": "乔治亚"
  },
  "群马": {
    "id": "群马"
  },
  "德罗贝塔-塞维林堡": {
    "id": "德罗贝塔-塞维林堡"
  },
  "加加埃毛加": {
    "id": "加加埃毛加"
  },
  "东哈萨克斯坦": {
    "id": "东哈萨克斯坦"
  },
  "朱迈利耶": {
    "id": "朱迈利耶"
  },
  "波希康市": {
    "id": "波希康市"
  },
  "布尔戈斯": {
    "id": "布尔戈斯"
  },
  "伊魁特": {
    "id": "伊魁特"
  },
  "几内亚比绍": {
    "id": "几内亚比绍"
  },
  "阿尔勒": {
    "id": "阿尔勒"
  },
  "大田": {
    "id": "大田"
  },
  "黎巴嫩山": {
    "id": "黎巴嫩山"
  },
  "上尼罗": {
    "id": "上尼罗"
  },
  "华潘": {
    "id": "华潘"
  },
  "代特莫尔特": {
    "id": "代特莫尔特"
  },
  "莫尔兹比港": {
    "id": "莫尔兹比港"
  },
  "戈梅利": {
    "id": "戈梅利"
  },
  "北方": {
    "id": "北方"
  },
  "里窝那": {
    "id": "里窝那"
  },
  "瓦辛基苏": {
    "id": "瓦辛基苏"
  },
  "滨海和山区": {
    "id": "滨海和山区"
  },
  "越南": {
    "id": "越南"
  },
  "科马亚瓜": {
    "id": "科马亚瓜"
  },
  "色军": {
    "id": "色军"
  },
  "奥沙纳": {
    "id": "奥沙纳"
  },
  "苏奇特佩克斯": {
    "id": "苏奇特佩克斯"
  },
  "新松奇": {
    "id": "新松奇"
  },
  "通杰利": {
    "id": "通杰利"
  },
  "塔那那利佛": {
    "id": "塔那那利佛"
  },
  "雅加达": {
    "id": "雅加达"
  },
  "戈公": {
    "id": "戈公"
  },
  "萨图·马雷": {
    "id": "萨图·马雷"
  },
  "北桑坦德": {
    "id": "北桑坦德"
  },
  "金伯利": {
    "id": "金伯利"
  },
  "圣菲利普": {
    "id": "圣菲利普"
  },
  "阿金斯科耶": {
    "id": "阿金斯科耶"
  },
  "穆兰卡": {
    "id": "穆兰卡"
  },
  "吉赞": {
    "id": "吉赞"
  },
  "巴布亚新几内亚": {
    "id": "巴布亚新几内亚"
  },
  "马里": {
    "id": "马里"
  },
  "年达鲁阿": {
    "id": "年达鲁阿"
  },
  "基恩乔乔": {
    "id": "基恩乔乔"
  },
  "新埃斯帕塔": {
    "id": "新埃斯帕塔"
  },
  "江原道": {
    "id": "江原道"
  },
  "莫普提": {
    "id": "莫普提"
  },
  "莱斯博斯": {
    "id": "莱斯博斯"
  },
  "马尼拉": {
    "id": "马尼拉"
  },
  "科科斯群岛": {
    "id": "科科斯群岛"
  },
  "哈杜马蒂": {
    "id": "哈杜马蒂"
  },
  "玛丽港": {
    "id": "玛丽港"
  },
  "汉特－曼西斯克": {
    "id": "汉特－曼西斯克"
  },
  "纳希切万": {
    "id": "纳希切万"
  },
  "凯内杜古": {
    "id": "凯内杜古"
  },
  "索非亚": {
    "id": "索非亚"
  },
  "赫罗纳": {
    "id": "赫罗纳"
  },
  "宁巴": {
    "id": "宁巴"
  },
  "埃迪尔内": {
    "id": "埃迪尔内"
  },
  "也门": {
    "id": "也门"
  },
  "西佛吉尼亚": {
    "id": "西佛吉尼亚"
  },
  "新疆维吾尔自治区": {
    "id": "新疆维吾尔自治区"
  },
  "楠榜": {
    "id": "楠榜"
  },
  "海参崴": {
    "id": "海参崴"
  },
  "萨达": {
    "id": "萨达"
  },
  "瓜纳卡斯特": {
    "id": "瓜纳卡斯特"
  },
  "part13": {
    "id": "part13"
  },
  "卡拉区": {
    "id": "卡拉区"
  },
  "比温巴": {
    "id": "比温巴"
  },
  "丹麦": {
    "id": "丹麦"
  },
  "巴特曼": {
    "id": "巴特曼"
  },
  "索马里": {
    "id": "索马里"
  },
  "甘蒙": {
    "id": "甘蒙"
  },
  "卡斯科伏": {
    "id": "卡斯科伏"
  },
  "戈里": {
    "id": "戈里"
  },
  "琼塔莱斯": {
    "id": "琼塔莱斯"
  },
  "达沙古兹": {
    "id": "达沙古兹"
  },
  "波里": {
    "id": "波里"
  },
  "迪法": {
    "id": "迪法"
  },
  "班吉直辖市": {
    "id": "班吉直辖市"
  },
  "卡伊": {
    "id": "卡伊"
  },
  "乌普萨拉": {
    "id": "乌普萨拉"
  },
  "马吉比": {
    "id": "马吉比"
  },
  "大阿克拉": {
    "id": "大阿克拉"
  },
  "库尔维奥戈": {
    "id": "库尔维奥戈"
  },
  "庆尚南道": {
    "id": "庆尚南道"
  },
  "千叶": {
    "id": "千叶"
  },
  "艾克斯": {
    "id": "艾克斯"
  },
  "阿姆兰": {
    "id": "阿姆兰"
  },
  "瓦朗斯": {
    "id": "瓦朗斯"
  },
  "万博": {
    "id": "万博"
  },
  "塔波拉": {
    "id": "塔波拉"
  },
  "萨莫拉－钦奇佩": {
    "id": "萨莫拉－钦奇佩"
  },
  "岐阜": {
    "id": "岐阜"
  },
  "吉尔伯特群岛": {
    "id": "吉尔伯特群岛"
  },
  "南曼兰": {
    "id": "南曼兰"
  },
  "南非": {
    "id": "南非"
  },
  "弗朗西斯科-莫拉桑": {
    "id": "弗朗西斯科-莫拉桑"
  },
  "伊万－弗兰科夫州": {
    "id": "伊万－弗兰科夫州"
  },
  "东伯比斯-科兰太因": {
    "id": "东伯比斯-科兰太因"
  },
  "瑟克特夫卡尔": {
    "id": "瑟克特夫卡尔"
  },
  "佛罗里达": {
    "id": "佛罗里达"
  },
  "木尔坦": {
    "id": "木尔坦"
  },
  "阿比亚": {
    "id": "阿比亚"
  },
  "阿斯科利皮切诺": {
    "id": "阿斯科利皮切诺"
  },
  "布尔干": {
    "id": "布尔干"
  },
  "阿菲永": {
    "id": "阿菲永"
  },
  "乌里": {
    "id": "乌里"
  },
  "佛罗伦萨": {
    "id": "佛罗伦萨"
  },
  "肯特": {
    "id": "肯特"
  },
  "卡尔斯": {
    "id": "卡尔斯"
  },
  "美属萨摩亚": {
    "id": "美属萨摩亚"
  },
  "西爪哇": {
    "id": "西爪哇"
  },
  "登盖莱": {
    "id": "登盖莱"
  },
  "阿克萨赖": {
    "id": "阿克萨赖"
  },
  "皮钦查": {
    "id": "皮钦查"
  },
  "济州特别自治道": {
    "id": "济州特别自治道"
  },
  "麦迪亚": {
    "id": "麦迪亚"
  },
  "蒂珀雷里": {
    "id": "蒂珀雷里"
  },
  "埃里温市": {
    "id": "埃里温市"
  },
  "峡谷": {
    "id": "峡谷"
  },
  "卢瓦马加纳": {
    "id": "卢瓦马加纳"
  },
  "纳米比亚": {
    "id": "纳米比亚"
  },
  "关塔那摩": {
    "id": "关塔那摩"
  },
  "凯里尼亚": {
    "id": "凯里尼亚"
  },
  "利特里姆": {
    "id": "利特里姆"
  },
  "马鲁古": {
    "id": "马鲁古"
  },
  "恩特拉杜罗伏日": {
    "id": "恩特拉杜罗伏日"
  },
  "穆桑达姆省": {
    "id": "穆桑达姆省"
  },
  "云南省": {
    "id": "云南省"
  },
  "中戈壁": {
    "id": "中戈壁"
  },
  "沙巴": {
    "id": "沙巴"
  },
  "阿苏艾": {
    "id": "阿苏艾"
  },
  "圣尼古拉岛": {
    "id": "圣尼古拉岛"
  },
  "阿富汗": {
    "id": "阿富汗"
  },
  "波兹南": {
    "id": "波兹南"
  },
  "陶公": {
    "id": "陶公"
  },
  "南萨哈林斯克": {
    "id": "南萨哈林斯克"
  },
  "尼特拉": {
    "id": "尼特拉"
  },
  "茨城": {
    "id": "茨城"
  },
  "贝宁": {
    "id": "贝宁"
  },
  "莫斯塔加纳姆": {
    "id": "莫斯塔加纳姆"
  },
  "下奥地利": {
    "id": "下奥地利"
  },
  "旺格努伊": {
    "id": "旺格努伊"
  },
  "韦莱-恩萨斯": {
    "id": "韦莱-恩萨斯"
  },
  "帕涅韦日斯": {
    "id": "帕涅韦日斯"
  },
  "奥鲁罗": {
    "id": "奥鲁罗"
  },
  "克耶邦": {
    "id": "克耶邦"
  },
  "琅勃拉邦": {
    "id": "琅勃拉邦"
  },
  "泰塔温": {
    "id": "泰塔温"
  },
  "加盖福毛加": {
    "id": "加盖福毛加"
  },
  "法马古斯塔": {
    "id": "法马古斯塔"
  },
  "马达加斯加": {
    "id": "马达加斯加"
  },
  "巴芬": {
    "id": "巴芬"
  },
  "丹吉尔": {
    "id": "丹吉尔"
  },
  "曼萨尼罗": {
    "id": "曼萨尼罗"
  },
  "吉斯伯恩": {
    "id": "吉斯伯恩"
  },
  "格雷文马赫": {
    "id": "格雷文马赫"
  },
  "广西壮族自治区": {
    "id": "广西壮族自治区"
  },
  "阿尔及尔": {
    "id": "阿尔及尔"
  },
  "比莱吉克": {
    "id": "比莱吉克"
  },
  "拜林市": {
    "id": "拜林市"
  },
  "雷西斯滕匹亚": {
    "id": "雷西斯滕匹亚"
  },
  "伯利兹": {
    "id": "伯利兹"
  },
  "热舒夫": {
    "id": "热舒夫"
  },
  "全罗南道": {
    "id": "全罗南道"
  },
  "马提尼克": {
    "id": "马提尼克"
  },
  "培拉特": {
    "id": "培拉特"
  },
  "瑞典": {
    "id": "瑞典"
  },
  "莱基皮亚": {
    "id": "莱基皮亚"
  },
  "柬埔寨": {
    "id": "柬埔寨"
  },
  "斯库台": {
    "id": "斯库台"
  },
  "干丹": {
    "id": "干丹"
  },
  "东方": {
    "id": "东方"
  },
  "华沙": {
    "id": "华沙"
  },
  "part14": {
    "id": "part14"
  },
  "邦达马河谷": {
    "id": "邦达马河谷"
  },
  "敖德萨": {
    "id": "敖德萨"
  },
  "米尼奥-利马": {
    "id": "米尼奥-利马"
  },
  "哈兰": {
    "id": "哈兰"
  },
  "土耳其": {
    "id": "土耳其"
  },
  "利贝雷克": {
    "id": "利贝雷克"
  },
  "马拉韦": {
    "id": "马拉韦"
  },
  "扎玛尔": {
    "id": "扎玛尔"
  },
  "卡穆利": {
    "id": "卡穆利"
  },
  "阿尔巴尤利亚": {
    "id": "阿尔巴尤利亚"
  },
  "上巴拉圭": {
    "id": "上巴拉圭"
  },
  "帕伦西亚": {
    "id": "帕伦西亚"
  },
  "北苏门答腊": {
    "id": "北苏门答腊"
  },
  "阿森": {
    "id": "阿森"
  },
  "三重": {
    "id": "三重"
  },
  "巴尔坎": {
    "id": "巴尔坎"
  },
  "艾因": {
    "id": "艾因"
  },
  "赫尔松州": {
    "id": "赫尔松州"
  },
  "库尔佩罗戈": {
    "id": "库尔佩罗戈"
  },
  "占贾": {
    "id": "占贾"
  },
  "黑斯廷斯": {
    "id": "黑斯廷斯"
  },
  "霍夫多尔普": {
    "id": "霍夫多尔普"
  },
  "帕斯科": {
    "id": "帕斯科"
  },
  "萨列哈尔德": {
    "id": "萨列哈尔德"
  },
  "莫罗贝": {
    "id": "莫罗贝"
  },
  "马萨卡": {
    "id": "马萨卡"
  },
  "克莱克斯多普": {
    "id": "克莱克斯多普"
  },
  "乌萨克": {
    "id": "乌萨克"
  },
  "沙赫京斯克": {
    "id": "沙赫京斯克"
  },
  "罗夫诺": {
    "id": "罗夫诺"
  },
  "上姆博穆": {
    "id": "上姆博穆"
  },
  "纽埃": {
    "id": "纽埃"
  },
  "阿马西亚": {
    "id": "阿马西亚"
  },
  "达沃": {
    "id": "达沃"
  },
  "埃德": {
    "id": "埃德"
  },
  "埃斯梅拉尔达斯": {
    "id": "埃斯梅拉尔达斯"
  },
  "曼德拉": {
    "id": "曼德拉"
  },
  "巴拿马": {
    "id": "巴拿马"
  },
  "奥果韦-伊温多": {
    "id": "奥果韦-伊温多"
  },
  "密克罗尼西亚": {
    "id": "密克罗尼西亚"
  },
  "宫崎": {
    "id": "宫崎"
  },
  "布隆克斯特斯普利特": {
    "id": "布隆克斯特斯普利特"
  },
  "田纳西": {
    "id": "田纳西"
  },
  "普利亚拉克斯": {
    "id": "普利亚拉克斯"
  },
  "提契诺": {
    "id": "提契诺"
  },
  "布勒伊拉": {
    "id": "布勒伊拉"
  },
  "北阿里": {
    "id": "北阿里"
  },
  "内蒙古自治区": {
    "id": "内蒙古自治区"
  },
  "吉达": {
    "id": "吉达"
  },
  "普洛耶什蒂": {
    "id": "普洛耶什蒂"
  },
  "库利阿坎": {
    "id": "库利阿坎"
  },
  "赛伊达": {
    "id": "赛伊达"
  },
  "开曼群岛": {
    "id": "开曼群岛"
  },
  "里法": {
    "id": "里法"
  },
  "北柳": {
    "id": "北柳"
  },
  "罗勇": {
    "id": "罗勇"
  },
  "布隆方丹": {
    "id": "布隆方丹"
  },
  "艾登": {
    "id": "艾登"
  },
  "伦敦": {
    "id": "伦敦"
  },
  "马赫迪耶": {
    "id": "马赫迪耶"
  },
  "奥尔杜": {
    "id": "奥尔杜"
  },
  "贝加莫": {
    "id": "贝加莫"
  },
  "大波兰地区戈茹夫": {
    "id": "大波兰地区戈茹夫"
  },
  "利蒙": {
    "id": "利蒙"
  },
  "南达科他": {
    "id": "南达科他"
  },
  "奥普兰": {
    "id": "奥普兰"
  },
  "克萨尔特南戈": {
    "id": "克萨尔特南戈"
  },
  "墨西哥": {
    "id": "墨西哥"
  },
  "卡拉克": {
    "id": "卡拉克"
  },
  "北尼兰杜": {
    "id": "北尼兰杜"
  },
  "乌布苏": {
    "id": "乌布苏"
  },
  "巴里马-瓦伊尼": {
    "id": "巴里马-瓦伊尼"
  },
  "浙江省": {
    "id": "浙江省"
  },
  "法国": {
    "id": "法国"
  },
  "莫诺": {
    "id": "莫诺"
  },
  "伊迪尔": {
    "id": "伊迪尔"
  },
  "萨马拉": {
    "id": "萨马拉"
  },
  "圣赫勒拿": {
    "id": "圣赫勒拿"
  },
  "奥兰乔": {
    "id": "奥兰乔"
  },
  "霍马斯": {
    "id": "霍马斯"
  },
  "米什洛维采": {
    "id": "米什洛维采"
  },
  "希诺特加": {
    "id": "希诺特加"
  },
  "阿姆斯特丹": {
    "id": "阿姆斯特丹"
  },
  "纳里扬马尔": {
    "id": "纳里扬马尔"
  },
  "美因兹": {
    "id": "美因兹"
  },
  "帕尧": {
    "id": "帕尧"
  },
  "阿散蒂": {
    "id": "阿散蒂"
  },
  "宿务": {
    "id": "宿务"
  },
  "part15": {
    "id": "part15"
  },
  "东马绍纳兰": {
    "id": "东马绍纳兰"
  },
  "哈拉帕": {
    "id": "哈拉帕"
  },
  "圣安德鲁斯": {
    "id": "圣安德鲁斯"
  },
  "基巴莱": {
    "id": "基巴莱"
  },
  "卡普乔鲁瓦": {
    "id": "卡普乔鲁瓦"
  },
  "坎大哈": {
    "id": "坎大哈"
  },
  "克钦邦": {
    "id": "克钦邦"
  },
  "阿图阿": {
    "id": "阿图阿"
  },
  "南哈萨克斯坦": {
    "id": "南哈萨克斯坦"
  },
  "波兰": {
    "id": "波兰"
  },
  "卡洛": {
    "id": "卡洛"
  },
  "忠清北道": {
    "id": "忠清北道"
  },
  "奥廖尔": {
    "id": "奥廖尔"
  },
  "索洛拉": {
    "id": "索洛拉"
  },
  "苦盏": {
    "id": "苦盏"
  },
  "莱里贝": {
    "id": "莱里贝"
  },
  "沃什": {
    "id": "沃什"
  },
  "阿达马瓦": {
    "id": "阿达马瓦"
  },
  "卡斯蒂利亚": {
    "id": "卡斯蒂利亚"
  },
  "秋明": {
    "id": "秋明"
  },
  "苏利亚": {
    "id": "苏利亚"
  },
  "里奥加耶戈斯": {
    "id": "里奥加耶戈斯"
  },
  "卡赫拉曼马拉什": {
    "id": "卡赫拉曼马拉什"
  },
  "清迈": {
    "id": "清迈"
  },
  "北碧": {
    "id": "北碧"
  },
  "贝伊德": {
    "id": "贝伊德"
  },
  "帕拉马里博": {
    "id": "帕拉马里博"
  },
  "帝力": {
    "id": "帝力"
  },
  "克罗托内": {
    "id": "克罗托内"
  },
  "福岛": {
    "id": "福岛"
  },
  "蒙克洛瓦": {
    "id": "蒙克洛瓦"
  },
  "米斯": {
    "id": "米斯"
  },
  "明斯特": {
    "id": "明斯特"
  },
  "塔巴采卡": {
    "id": "塔巴采卡"
  },
  "基利斯": {
    "id": "基利斯"
  },
  "库克斯": {
    "id": "库克斯"
  },
  "桑马滕加": {
    "id": "桑马滕加"
  },
  "贝沙尔": {
    "id": "贝沙尔"
  },
  "里弗塞斯": {
    "id": "里弗塞斯"
  },
  "穆哈拉格": {
    "id": "穆哈拉格"
  },
  "哈瓦那城": {
    "id": "哈瓦那城"
  },
  "瓦尔纳": {
    "id": "瓦尔纳"
  },
  "达叻": {
    "id": "达叻"
  },
  "圣安德烈斯-普罗维登西亚": {
    "id": "圣安德烈斯-普罗维登西亚"
  },
  "马特莱": {
    "id": "马特莱"
  },
  "古尔马": {
    "id": "古尔马"
  },
  "西努沙登加拉": {
    "id": "西努沙登加拉"
  },
  "印多尔": {
    "id": "印多尔"
  },
  "科蒂多": {
    "id": "科蒂多"
  },
  "特鲁希略": {
    "id": "特鲁希略"
  },
  "莫罗托": {
    "id": "莫罗托"
  },
  "格雷茅斯": {
    "id": "格雷茅斯"
  },
  "瓜维亚雷": {
    "id": "瓜维亚雷"
  },
  "里昂": {
    "id": "里昂"
  },
  "比亚瓦波德拉斯卡": {
    "id": "比亚瓦波德拉斯卡"
  },
  "特鲁埃尔": {
    "id": "特鲁埃尔"
  },
  "桑德贝": {
    "id": "桑德贝"
  },
  "萨瓦伊岛": {
    "id": "萨瓦伊岛"
  },
  "长野": {
    "id": "长野"
  },
  "图伊": {
    "id": "图伊"
  },
  "乌斯怀亚": {
    "id": "乌斯怀亚"
  },
  "弗沃茨瓦韦克": {
    "id": "弗沃茨瓦韦克"
  },
  "阿拉瓦": {
    "id": "阿拉瓦"
  },
  "哈勒里民族": {
    "id": "哈勒里民族"
  },
  "居米什哈内": {
    "id": "居米什哈内"
  },
  "陶拉格": {
    "id": "陶拉格"
  },
  "马德普拉塔": {
    "id": "马德普拉塔"
  },
  "圣维森特": {
    "id": "圣维森特"
  },
  "廖内": {
    "id": "廖内"
  },
  "瓦德": {
    "id": "瓦德"
  },
  "德班": {
    "id": "德班"
  },
  "本戈": {
    "id": "本戈"
  },
  "特伦托": {
    "id": "特伦托"
  },
  "印第安那": {
    "id": "印第安那"
  },
  "蓬塔德尔加达": {
    "id": "蓬塔德尔加达"
  },
  "马努法伊": {
    "id": "马努法伊"
  },
  "伊万诺沃": {
    "id": "伊万诺沃"
  },
  "特立尼达和多巴哥": {
    "id": "特立尼达和多巴哥"
  },
  "西曼兰": {
    "id": "西曼兰"
  },
  "安曼": {
    "id": "安曼"
  },
  "波茨坦": {
    "id": "波茨坦"
  },
  "哈伊勒": {
    "id": "哈伊勒"
  },
  "中波斯尼亚": {
    "id": "中波斯尼亚"
  },
  "武里南": {
    "id": "武里南"
  },
  "第聂伯罗波得罗夫斯克": {
    "id": "第聂伯罗波得罗夫斯克"
  },
  "大分": {
    "id": "大分"
  },
  "博恩霍尔姆": {
    "id": "博恩霍尔姆"
  },
  "北京市": {
    "id": "北京市"
  },
  "卡尔马": {
    "id": "卡尔马"
  },
  "徳岛": {
    "id": "徳岛"
  },
  "吉比利": {
    "id": "吉比利"
  },
  "萨格勒布市": {
    "id": "萨格勒布市"
  },
  "茶胶": {
    "id": "茶胶"
  },
  "荷兰": {
    "id": "荷兰"
  },
  "罗安达": {
    "id": "罗安达"
  },
  "part16": {
    "id": "part16"
  },
  "纳米贝": {
    "id": "纳米贝"
  },
  "黎逸": {
    "id": "黎逸"
  },
  "纳罗克": {
    "id": "纳罗克"
  },
  "安卡拉": {
    "id": "安卡拉"
  },
  "图阿马萨加": {
    "id": "图阿马萨加"
  },
  "梅尔库里亚丘克": {
    "id": "梅尔库里亚丘克"
  },
  "神奈川": {
    "id": "神奈川"
  },
  "沙里院": {
    "id": "沙里院"
  },
  "北马塔贝莱兰": {
    "id": "北马塔贝莱兰"
  },
  "圣佩德罗": {
    "id": "圣佩德罗"
  },
  "纳纳-格里比齐": {
    "id": "纳纳-格里比齐"
  },
  "马查科斯": {
    "id": "马查科斯"
  },
  "圣米格尔": {
    "id": "圣米格尔"
  },
  "肯尼亚": {
    "id": "肯尼亚"
  },
  "姆巴拉兹": {
    "id": "姆巴拉兹"
  },
  "大马士革": {
    "id": "大马士革"
  },
  "布尔加斯": {
    "id": "布尔加斯"
  },
  "潘多": {
    "id": "潘多"
  },
  "巴塞尔乡村": {
    "id": "巴塞尔乡村"
  },
  "圣地亚哥": {
    "id": "圣地亚哥"
  },
  "卡盖拉": {
    "id": "卡盖拉"
  },
  "新南威尔士": {
    "id": "新南威尔士"
  },
  "特隆普斯堡": {
    "id": "特隆普斯堡"
  },
  "韩国": {
    "id": "韩国"
  },
  "费尔干纳": {
    "id": "费尔干纳"
  },
  "圣卡塔琳娜": {
    "id": "圣卡塔琳娜"
  },
  "马赛": {
    "id": "马赛"
  },
  "别洛瓦尔-比洛戈拉": {
    "id": "别洛瓦尔-比洛戈拉"
  },
  "南阿里": {
    "id": "南阿里"
  },
  "甘肃省": {
    "id": "甘肃省"
  },
  "恩通加莫": {
    "id": "恩通加莫"
  },
  "萨尔岛": {
    "id": "萨尔岛"
  },
  "岛根": {
    "id": "岛根"
  },
  "奥尔良": {
    "id": "奥尔良"
  },
  "帕拉": {
    "id": "帕拉"
  },
  "万象": {
    "id": "万象"
  },
  "阿达纳": {
    "id": "阿达纳"
  },
  "比斯开": {
    "id": "比斯开"
  },
  "克鲁努贝里": {
    "id": "克鲁努贝里"
  },
  "兰巴耶克": {
    "id": "兰巴耶克"
  },
  "斯法克斯": {
    "id": "斯法克斯"
  },
  "加纳": {
    "id": "加纳"
  },
  "克拉科夫": {
    "id": "克拉科夫"
  },
  "利马": {
    "id": "利马"
  },
  "纳库鲁": {
    "id": "纳库鲁"
  },
  "咸兴": {
    "id": "咸兴"
  },
  "克拉皮纳-扎戈列": {
    "id": "克拉皮纳-扎戈列"
  },
  "鄂尔浑": {
    "id": "鄂尔浑"
  },
  "扎达尔": {
    "id": "扎达尔"
  },
  "曼岛": {
    "id": "曼岛"
  },
  "扎萨夫": {
    "id": "扎萨夫"
  },
  "梅克内斯": {
    "id": "梅克内斯"
  },
  "埃尔普罗格雷索": {
    "id": "埃尔普罗格雷索"
  },
  "努姆比埃尔": {
    "id": "努姆比埃尔"
  },
  "帕维亚": {
    "id": "帕维亚"
  },
  "瓦基索": {
    "id": "瓦基索"
  },
  "德雷达瓦": {
    "id": "德雷达瓦"
  },
  "卡宾达": {
    "id": "卡宾达"
  },
  "格劳宾登": {
    "id": "格劳宾登"
  },
  "海湾群岛": {
    "id": "海湾群岛"
  },
  "戈壁苏木贝尔": {
    "id": "戈壁苏木贝尔"
  },
  "阿尔马维尔": {
    "id": "阿尔马维尔"
  },
  "萨班特": {
    "id": "萨班特"
  },
  "伊朗": {
    "id": "伊朗"
  },
  "曼海姆": {
    "id": "曼海姆"
  },
  "马纳图托": {
    "id": "马纳图托"
  },
  "坦巴昆达": {
    "id": "坦巴昆达"
  },
  "达利": {
    "id": "达利"
  },
  "迈赫拉": {
    "id": "迈赫拉"
  },
  "卢韦罗": {
    "id": "卢韦罗"
  },
  "普斯科夫": {
    "id": "普斯科夫"
  },
  "锡勒亚奈": {
    "id": "锡勒亚奈"
  },
  "坦桑尼亚": {
    "id": "坦桑尼亚"
  },
  "图拉马哈谢": {
    "id": "图拉马哈谢"
  },
  "南特伦德拉格": {
    "id": "南特伦德拉格"
  },
  "科默韦讷": {
    "id": "科默韦讷"
  },
  "巴奇-基什孔": {
    "id": "巴奇-基什孔"
  },
  "波特兰": {
    "id": "波特兰"
  },
  "桑给巴尔市和西": {
    "id": "桑给巴尔市和西"
  },
  "伊塞克湖": {
    "id": "伊塞克湖"
  },
  "普罗夫迪夫": {
    "id": "普罗夫迪夫"
  },
  "汉堡": {
    "id": "汉堡"
  },
  "布尔根兰": {
    "id": "布尔根兰"
  },
  "基图伊": {
    "id": "基图伊"
  },
  "凯里": {
    "id": "凯里"
  },
  "阿勒颇": {
    "id": "阿勒颇"
  },
  "图斯特拉-古铁雷斯": {
    "id": "图斯特拉-古铁雷斯"
  },
  "迈利赛": {
    "id": "迈利赛"
  },
  "沃克拉": {
    "id": "沃克拉"
  },
  "加里宁格勒": {
    "id": "加里宁格勒"
  },
  "西藏自治区": {
    "id": "西藏自治区"
  },
  "列支敦士登": {
    "id": "列支敦士登"
  },
  "迪亚巴克尔": {
    "id": "迪亚巴克尔"
  },
  "基戈马": {
    "id": "基戈马"
  },
  "伦皮拉": {
    "id": "伦皮拉"
  },
  "加布": {
    "id": "加布"
  },
  "叶卡捷林堡": {
    "id": "叶卡捷林堡"
  },
  "图利亚拉": {
    "id": "图利亚拉"
  },
  "part17": {
    "id": "part17"
  },
  "莫雷利亚": {
    "id": "莫雷利亚"
  },
  "宾博": {
    "id": "宾博"
  },
  "吉普斯夸": {
    "id": "吉普斯夸"
  },
  "布拉戈维申斯克": {
    "id": "布拉戈维申斯克"
  },
  "上奥地利": {
    "id": "上奥地利"
  },
  "伊丽莎白港": {
    "id": "伊丽莎白港"
  },
  "沙夫豪森": {
    "id": "沙夫豪森"
  },
  "色贡": {
    "id": "色贡"
  },
  "莱比锡": {
    "id": "莱比锡"
  },
  "格罗布莱斯达尔": {
    "id": "格罗布莱斯达尔"
  },
  "斐济": {
    "id": "斐济"
  },
  "克麦罗沃": {
    "id": "克麦罗沃"
  },
  "奥博克区": {
    "id": "奥博克区"
  },
  "道拉吉里": {
    "id": "道拉吉里"
  },
  "大邱": {
    "id": "大邱"
  },
  "加兹-纳杰孔-索尔诺克": {
    "id": "加兹-纳杰孔-索尔诺克"
  },
  "塞尔希培": {
    "id": "塞尔希培"
  },
  "利比亚": {
    "id": "利比亚"
  },
  "帕丘卡": {
    "id": "帕丘卡"
  },
  "北榄坡": {
    "id": "北榄坡"
  },
  "图拉": {
    "id": "图拉"
  },
  "科希策": {
    "id": "科希策"
  },
  "朗福德": {
    "id": "朗福德"
  },
  "贝凯什": {
    "id": "贝凯什"
  },
  "苏鲁": {
    "id": "苏鲁"
  },
  "贝桑松": {
    "id": "贝桑松"
  },
  "彭吉肯特": {
    "id": "彭吉肯特"
  },
  "东新不列颠": {
    "id": "东新不列颠"
  },
  "保加利亚": {
    "id": "保加利亚"
  },
  "艾尔亚奈": {
    "id": "艾尔亚奈"
  },
  "布加勒斯特": {
    "id": "布加勒斯特"
  },
  "圣萨尔瓦多": {
    "id": "圣萨尔瓦多"
  },
  "塞诺": {
    "id": "塞诺"
  },
  "布韦岛": {
    "id": "布韦岛"
  },
  "科斯特罗马": {
    "id": "科斯特罗马"
  },
  "塔里哈": {
    "id": "塔里哈"
  },
  "基克拉迪": {
    "id": "基克拉迪"
  },
  "南苏瓦迪瓦": {
    "id": "南苏瓦迪瓦"
  },
  "拉彭兰塔": {
    "id": "拉彭兰塔"
  },
  "北端": {
    "id": "北端"
  },
  "基达尔": {
    "id": "基达尔"
  },
  "弗里尼欣": {
    "id": "弗里尼欣"
  },
  "大里贝拉": {
    "id": "大里贝拉"
  },
  "印度尼西亚": {
    "id": "印度尼西亚"
  },
  "阿伊莱乌": {
    "id": "阿伊莱乌"
  },
  "北部区": {
    "id": "北部区"
  },
  "奥地利": {
    "id": "奥地利"
  },
  "马塔莫罗斯": {
    "id": "马塔莫罗斯"
  },
  "斯洛伐克": {
    "id": "斯洛伐克"
  },
  "托雷翁": {
    "id": "托雷翁"
  },
  "杜尚别": {
    "id": "杜尚别"
  },
  "托坎廷斯": {
    "id": "托坎廷斯"
  },
  "萨尔塔": {
    "id": "萨尔塔"
  },
  "索亚潘戈": {
    "id": "索亚潘戈"
  },
  "锡龙科": {
    "id": "锡龙科"
  },
  "布古里巴": {
    "id": "布古里巴"
  },
  "圣托马斯": {
    "id": "圣托马斯"
  },
  "什切青": {
    "id": "什切青"
  },
  "科森扎": {
    "id": "科森扎"
  },
  "莱里达": {
    "id": "莱里达"
  },
  "拉特纳普勒": {
    "id": "拉特纳普勒"
  },
  "卡塔奎": {
    "id": "卡塔奎"
  },
  "琼格拉德": {
    "id": "琼格拉德"
  },
  "扎纳奥津": {
    "id": "扎纳奥津"
  },
  "马朗帕": {
    "id": "马朗帕"
  },
  "胡志明市": {
    "id": "胡志明市"
  },
  "卡瓜苏": {
    "id": "卡瓜苏"
  },
  "蒙得维的亚": {
    "id": "蒙得维的亚"
  },
  "图瓦卢": {
    "id": "图瓦卢"
  },
  "文茨皮尔斯": {
    "id": "文茨皮尔斯"
  },
  "斯瓦尔巴和扬马廷": {
    "id": "斯瓦尔巴和扬马廷"
  },
  "塞浦路斯": {
    "id": "塞浦路斯"
  },
  "布西亚": {
    "id": "布西亚"
  },
  "英格兰": {
    "id": "英格兰"
  },
  "达": {
    "id": "达"
  },
  "塞图巴尔半岛": {
    "id": "塞图巴尔半岛"
  },
  "考拉克": {
    "id": "考拉克"
  },
  "马哈赞加": {
    "id": "马哈赞加"
  },
  "科斯塔奈": {
    "id": "科斯塔奈"
  },
  "提里斯-宰穆尔": {
    "id": "提里斯-宰穆尔"
  },
  "昆士敦": {
    "id": "昆士敦"
  },
  "圣安唐岛": {
    "id": "圣安唐岛"
  },
  "索里亚诺": {
    "id": "索里亚诺"
  },
  "彼得罗扎沃茨克": {
    "id": "彼得罗扎沃茨克"
  },
  "汤加塔布": {
    "id": "汤加塔布"
  },
  "法塞莱莱阿加": {
    "id": "法塞莱莱阿加"
  },
  "萨那": {
    "id": "萨那"
  },
  "锡西里": {
    "id": "锡西里"
  },
  "科恰班巴": {
    "id": "科恰班巴"
  },
  "马萨亚": {
    "id": "马萨亚"
  },
  "杜塞尔多夫": {
    "id": "杜塞尔多夫"
  },
  "乌季达": {
    "id": "乌季达"
  },
  "奥尔托": {
    "id": "奥尔托"
  },
  "夏洛特敦": {
    "id": "夏洛特敦"
  },
  "埃斯基谢希尔": {
    "id": "埃斯基谢希尔"
  },
  "帕利萨": {
    "id": "帕利萨"
  },
  "part18": {
    "id": "part18"
  },
  "塔尔图斯": {
    "id": "塔尔图斯"
  },
  "马托格罗索": {
    "id": "马托格罗索"
  },
  "卡斯特利翁": {
    "id": "卡斯特利翁"
  },
  "乌伊拉": {
    "id": "乌伊拉"
  },
  "钦博特": {
    "id": "钦博特"
  },
  "阿尔特温": {
    "id": "阿尔特温"
  },
  "布拉格直辖市": {
    "id": "布拉格直辖市"
  },
  "福建省": {
    "id": "福建省"
  },
  "阿尔梅勒": {
    "id": "阿尔梅勒"
  },
  "萨兰": {
    "id": "萨兰"
  },
  "西摩兰": {
    "id": "西摩兰"
  },
  "鲁伊吉": {
    "id": "鲁伊吉"
  },
  "科希马": {
    "id": "科希马"
  },
  "康涅狄格": {
    "id": "康涅狄格"
  },
  "巴甫洛达尔": {
    "id": "巴甫洛达尔"
  },
  "卡拉干达": {
    "id": "卡拉干达"
  },
  "基特古姆": {
    "id": "基特古姆"
  },
  "外喀尔巴阡": {
    "id": "外喀尔巴阡"
  },
  "约罗": {
    "id": "约罗"
  },
  "下韦拉帕斯": {
    "id": "下韦拉帕斯"
  },
  "锡萨克-莫斯拉维纳": {
    "id": "锡萨克-莫斯拉维纳"
  },
  "韦尔切利": {
    "id": "韦尔切利"
  },
  "马扎里沙里夫": {
    "id": "马扎里沙里夫"
  },
  "奥马赫科": {
    "id": "奥马赫科"
  },
  "下萨桑德拉": {
    "id": "下萨桑德拉"
  },
  "西隆": {
    "id": "西隆"
  },
  "埃龙戈": {
    "id": "埃龙戈"
  },
  "东爪哇": {
    "id": "东爪哇"
  },
  "法蒂克": {
    "id": "法蒂克"
  },
  "莫克瓜": {
    "id": "莫克瓜"
  },
  "包斯卡": {
    "id": "包斯卡"
  },
  "阿速坡": {
    "id": "阿速坡"
  },
  "塔尔图": {
    "id": "塔尔图"
  },
  "巴厘": {
    "id": "巴厘"
  },
  "因帕尔": {
    "id": "因帕尔"
  },
  "夸察夸拉克斯": {
    "id": "夸察夸拉克斯"
  },
  "安集延": {
    "id": "安集延"
  },
  "穆本德": {
    "id": "穆本德"
  },
  "圣马丁": {
    "id": "圣马丁"
  },
  "拉腊": {
    "id": "拉腊"
  },
  "蒂拉贝里": {
    "id": "蒂拉贝里"
  },
  "乌姆布阿基": {
    "id": "乌姆布阿基"
  },
  "阿尔达罕": {
    "id": "阿尔达罕"
  },
  "卜拉克纳": {
    "id": "卜拉克纳"
  },
  "米西奥内斯": {
    "id": "米西奥内斯"
  },
  "马德巴": {
    "id": "马德巴"
  },
  "明古鲁": {
    "id": "明古鲁"
  },
  "肯塔基": {
    "id": "肯塔基"
  },
  "卡瓦拉蒂": {
    "id": "卡瓦拉蒂"
  },
  "库尔干-秋别": {
    "id": "库尔干-秋别"
  },
  "莫哈莱斯胡克": {
    "id": "莫哈莱斯胡克"
  },
  "埼玉": {
    "id": "埼玉"
  },
  "纳纳-曼贝雷": {
    "id": "纳纳-曼贝雷"
  },
  "库克群岛": {
    "id": "库克群岛"
  },
  "瓜伊拉": {
    "id": "瓜伊拉"
  },
  "帕拉纳": {
    "id": "帕拉纳"
  },
  "蒙多基里": {
    "id": "蒙多基里"
  },
  "实皆省": {
    "id": "实皆省"
  },
  "布鲁里": {
    "id": "布鲁里"
  },
  "维尔纽斯": {
    "id": "维尔纽斯"
  },
  "冈祖尔古": {
    "id": "冈祖尔古"
  },
  "内布拉斯加": {
    "id": "内布拉斯加"
  },
  "铁米尔套": {
    "id": "铁米尔套"
  },
  "科利马": {
    "id": "科利马"
  },
  "托尔巴": {
    "id": "托尔巴"
  },
  "叶尔加瓦": {
    "id": "叶尔加瓦"
  },
  "萨加玛塔": {
    "id": "萨加玛塔"
  },
  "信武里": {
    "id": "信武里"
  },
  "韦西加诺": {
    "id": "韦西加诺"
  },
  "蒙特塞拉多": {
    "id": "蒙特塞拉多"
  },
  "金迪奥": {
    "id": "金迪奥"
  },
  "内贝拉南": {
    "id": "内贝拉南"
  },
  "胡蒂亚帕": {
    "id": "胡蒂亚帕"
  },
  "华富里": {
    "id": "华富里"
  },
  "苏克雷": {
    "id": "苏克雷"
  },
  "瓦努科": {
    "id": "瓦努科"
  },
  "东戈壁": {
    "id": "东戈壁"
  },
  "维也纳": {
    "id": "维也纳"
  },
  "锡诺": {
    "id": "锡诺"
  },
  "辽宁省": {
    "id": "辽宁省"
  },
  "阿亚库乔": {
    "id": "阿亚库乔"
  },
  "胡富夫": {
    "id": "胡富夫"
  },
  "新西伯利亚": {
    "id": "新西伯利亚"
  },
  "菲特烈堡": {
    "id": "菲特烈堡"
  },
  "哈德": {
    "id": "哈德"
  },
  "内贝拉北": {
    "id": "内贝拉北"
  },
  "山口": {
    "id": "山口"
  },
  "巴哈马": {
    "id": "巴哈马"
  },
  "莫希科": {
    "id": "莫希科"
  },
  "北苏拉威西": {
    "id": "北苏拉威西"
  },
  "圣罗莎": {
    "id": "圣罗莎"
  },
  "西黑塞哥维那": {
    "id": "西黑塞哥维那"
  },
  "湖北省": {
    "id": "湖北省"
  },
  "内华达": {
    "id": "内华达"
  },
  "蓬特韦德拉": {
    "id": "蓬特韦德拉"
  },
  "凯格勒": {
    "id": "凯格勒"
  },
  "特尔古日乌": {
    "id": "特尔古日乌"
  },
  "多米尼加": {
    "id": "多米尼加"
  },
  "塔梅加": {
    "id": "塔梅加"
  },
  "伊洛瓦底省": {
    "id": "伊洛瓦底省"
  },
  "科摩": {
    "id": "科摩"
  },
  "奇尔潘辛戈": {
    "id": "奇尔潘辛戈"
  },
  "马德里": {
    "id": "马德里"
  },
  "巴哈": {
    "id": "巴哈"
  },
  "富山": {
    "id": "富山"
  },
  "南蒂拉杜马蒂": {
    "id": "南蒂拉杜马蒂"
  },
  "海米斯穆谢特": {
    "id": "海米斯穆谢特"
  },
  "斯拉蒂纳": {
    "id": "斯拉蒂纳"
  },
  "山后": {
    "id": "山后"
  },
  "南浦": {
    "id": "南浦"
  },
  "part19": {
    "id": "part19"
  },
  "重庆市": {
    "id": "重庆市"
  },
  "碧差汶": {
    "id": "碧差汶"
  },
  "克拉伦登": {
    "id": "克拉伦登"
  },
  "麦纳麦": {
    "id": "麦纳麦"
  },
  "大巴萨": {
    "id": "大巴萨"
  },
  "乔科": {
    "id": "乔科"
  },
  "安徽省": {
    "id": "安徽省"
  },
  "圣马科斯": {
    "id": "圣马科斯"
  },
  "巴瓦": {
    "id": "巴瓦"
  },
  "加拿大": {
    "id": "加拿大"
  },
  "高原区": {
    "id": "高原区"
  },
  "北岸": {
    "id": "北岸"
  },
  "基奇纳": {
    "id": "基奇纳"
  },
  "宮城": {
    "id": "宮城"
  },
  "萨尔茨堡": {
    "id": "萨尔茨堡"
  },
  "恩泽雷科雷": {
    "id": "恩泽雷科雷"
  },
  "德梅拉拉-马海卡": {
    "id": "德梅拉拉-马海卡"
  },
  "南乔治亚和南桑德威奇群岛": {
    "id": "南乔治亚和南桑德威奇群岛"
  },
  "昌迪加尔": {
    "id": "昌迪加尔"
  },
  "伯力": {
    "id": "伯力"
  },
  "阿平顿": {
    "id": "阿平顿"
  },
  "本迪布焦": {
    "id": "本迪布焦"
  },
  "克尔谢希尔": {
    "id": "克尔谢希尔"
  },
  "提格雷": {
    "id": "提格雷"
  },
  "下阿连特茹": {
    "id": "下阿连特茹"
  },
  "利马索尔": {
    "id": "利马索尔"
  },
  "哈马德": {
    "id": "哈马德"
  },
  "卡尔巴卡尔": {
    "id": "卡尔巴卡尔"
  },
  "巴塞尔城市": {
    "id": "巴塞尔城市"
  },
  "中马绍纳兰": {
    "id": "中马绍纳兰"
  },
  "阿什杜德": {
    "id": "阿什杜德"
  },
  "芬兰": {
    "id": "芬兰"
  },
  "甘托克": {
    "id": "甘托克"
  },
  "布尔萨": {
    "id": "布尔萨"
  },
  "圣安娜": {
    "id": "圣安娜"
  },
  "不来梅": {
    "id": "不来梅"
  },
  "布拉": {
    "id": "布拉"
  },
  "阿鲁巴": {
    "id": "阿鲁巴"
  },
  "卡焦戈": {
    "id": "卡焦戈"
  },
  "所罗门群岛": {
    "id": "所罗门群岛"
  },
  "克拉斯拉瓦": {
    "id": "克拉斯拉瓦"
  },
  "萨雷": {
    "id": "萨雷"
  },
  "斯坦港": {
    "id": "斯坦港"
  },
  "塔博沙尔": {
    "id": "塔博沙尔"
  },
  "光州": {
    "id": "光州"
  },
  "万丹": {
    "id": "万丹"
  },
  "基里尼亚加": {
    "id": "基里尼亚加"
  },
  "那空帕农": {
    "id": "那空帕农"
  },
  "利比里亚": {
    "id": "利比里亚"
  },
  "西新不列颠": {
    "id": "西新不列颠"
  },
  "沃姆扎": {
    "id": "沃姆扎"
  },
  "布列斯特": {
    "id": "布列斯特"
  },
  "克恩顿": {
    "id": "克恩顿"
  },
  "南宽扎": {
    "id": "南宽扎"
  },
  "豪尔": {
    "id": "豪尔"
  },
  "旺阿雷": {
    "id": "旺阿雷"
  },
  "奥里斯塔诺": {
    "id": "奥里斯塔诺"
  },
  "莱顿": {
    "id": "莱顿"
  },
  "伊希约洛": {
    "id": "伊希约洛"
  },
  "陶马鲁努伊": {
    "id": "陶马鲁努伊"
  },
  "奥里萨巴": {
    "id": "奥里萨巴"
  },
  "姆贝亚": {
    "id": "姆贝亚"
  },
  "西诺尔兰": {
    "id": "西诺尔兰"
  },
  "希赫尔": {
    "id": "希赫尔"
  },
  "阿蒂加斯": {
    "id": "阿蒂加斯"
  },
  "蒂米什瓦拉": {
    "id": "蒂米什瓦拉"
  },
  "彼得库夫": {
    "id": "彼得库夫"
  },
  "科贾埃利": {
    "id": "科贾埃利"
  },
  "库苏古尔": {
    "id": "库苏古尔"
  },
  "科法尔尼洪": {
    "id": "科法尔尼洪"
  },
  "斯塔夫罗波尔": {
    "id": "斯塔夫罗波尔"
  },
  "佐贺": {
    "id": "佐贺"
  },
  "巴亚马雷": {
    "id": "巴亚马雷"
  },
  "奥卡万戈": {
    "id": "奥卡万戈"
  },
  "捷克共和国": {
    "id": "捷克共和国"
  },
  "宗德韦奥戈": {
    "id": "宗德韦奥戈"
  },
  "焦夫": {
    "id": "焦夫"
  },
  "伊萨瓦尔": {
    "id": "伊萨瓦尔"
  },
  "北米拉杜马杜卢": {
    "id": "北米拉杜马杜卢"
  },
  "萨尔杜斯": {
    "id": "萨尔杜斯"
  },
  "莫约": {
    "id": "莫约"
  },
  "佐洛": {
    "id": "佐洛"
  },
  "特瓦坎": {
    "id": "特瓦坎"
  },
  "埃基巴斯图兹": {
    "id": "埃基巴斯图兹"
  },
  "part20": {
    "id": "part20"
  },
  "安道尔城": {
    "id": "安道尔城"
  },
  "科罗拉多": {
    "id": "科罗拉多"
  },
  "塔朱拉区": {
    "id": "塔朱拉区"
  },
  "苏瓦乌基": {
    "id": "苏瓦乌基"
  },
  "上海市": {
    "id": "上海市"
  },
  "弗拉基米尔": {
    "id": "弗拉基米尔"
  },
  "塔兰托": {
    "id": "塔兰托"
  },
  "莱科": {
    "id": "莱科"
  },
  "西撒哈拉": {
    "id": "西撒哈拉"
  },
  "乌泰他尼": {
    "id": "乌泰他尼"
  },
  "托泽尔": {
    "id": "托泽尔"
  },
  "桑加-姆巴埃雷": {
    "id": "桑加-姆巴埃雷"
  },
  "瓦哈卡": {
    "id": "瓦哈卡"
  },
  "莱切": {
    "id": "莱切"
  },
  "哈德拉毛": {
    "id": "哈德拉毛"
  },
  "约翰内斯堡": {
    "id": "约翰内斯堡"
  },
  "尚古古": {
    "id": "尚古古"
  },
  "西苏门答腊": {
    "id": "西苏门答腊"
  },
  "卢甘斯克": {
    "id": "卢甘斯克"
  },
  "香川": {
    "id": "香川"
  },
  "文尼察": {
    "id": "文尼察"
  },
  "考卡": {
    "id": "考卡"
  },
  "贝尔瓦": {
    "id": "贝尔瓦"
  },
  "阿勒": {
    "id": "阿勒"
  },
  "葡萄牙": {
    "id": "葡萄牙"
  },
  "熊本": {
    "id": "熊本"
  },
  "拉木": {
    "id": "拉木"
  },
  "佩里": {
    "id": "佩里"
  },
  "基博加": {
    "id": "基博加"
  },
  "沃罗涅什": {
    "id": "沃罗涅什"
  },
  "新罕布什尔": {
    "id": "新罕布什尔"
  },
  "得土安": {
    "id": "得土安"
  },
  "盖尔达耶": {
    "id": "盖尔达耶"
  },
  "杜兰戈": {
    "id": "杜兰戈"
  },
  "塔伊夫": {
    "id": "塔伊夫"
  },
  "西部": {
    "id": "西部"
  },
  "彼德马里茨堡": {
    "id": "彼德马里茨堡"
  },
  "里士满": {
    "id": "里士满"
  },
  "宗古尔达克": {
    "id": "宗古尔达克"
  },
  "乌汶": {
    "id": "乌汶"
  },
  "坎波巴索": {
    "id": "坎波巴索"
  },
  "戈西": {
    "id": "戈西"
  },
  "德累斯顿": {
    "id": "德累斯顿"
  },
  "波德戈里察": {
    "id": "波德戈里察"
  },
  "高知": {
    "id": "高知"
  },
  "阿鲁阿": {
    "id": "阿鲁阿"
  },
  "大城": {
    "id": "大城"
  },
  "诺加莱斯": {
    "id": "诺加莱斯"
  },
  "阿瓦查潘": {
    "id": "阿瓦查潘"
  },
  "圣胡安河": {
    "id": "圣胡安河"
  },
  "博帕尔": {
    "id": "博帕尔"
  },
  "大角山": {
    "id": "大角山"
  },
  "掸邦": {
    "id": "掸邦"
  },
  "中爪哇": {
    "id": "中爪哇"
  },
  "塔菲阿": {
    "id": "塔菲阿"
  },
  "库鲁曼": {
    "id": "库鲁曼"
  },
  "穆拉": {
    "id": "穆拉"
  },
  "德国": {
    "id": "德国"
  },
  "萨卡帕": {
    "id": "萨卡帕"
  },
  "巴特纳": {
    "id": "巴特纳"
  },
  "伍斯特": {
    "id": "伍斯特"
  },
  "库鲁内格勒": {
    "id": "库鲁内格勒"
  },
  "罗森": {
    "id": "罗森"
  },
  "洪都拉斯": {
    "id": "洪都拉斯"
  },
  "马塞卢": {
    "id": "马塞卢"
  },
  "纳乌里": {
    "id": "纳乌里"
  },
  "劳斯": {
    "id": "劳斯"
  },
  "布斯克吕": {
    "id": "布斯克吕"
  },
  "基龙多": {
    "id": "基龙多"
  },
  "普吉": {
    "id": "普吉"
  },
  "阿卢克斯内": {
    "id": "阿卢克斯内"
  },
  "西约特兰": {
    "id": "西约特兰"
  },
  "罗德岛": {
    "id": "罗德岛"
  },
  "东阿格德尔": {
    "id": "东阿格德尔"
  },
  "阿加德兹": {
    "id": "阿加德兹"
  },
  "胡宁": {
    "id": "胡宁"
  },
  "安提瓜岛和巴布达": {
    "id": "安提瓜岛和巴布达"
  },
  "格罗德诺": {
    "id": "格罗德诺"
  },
  "北宽扎": {
    "id": "北宽扎"
  },
  "洛雷托": {
    "id": "洛雷托"
  },
  "前杭爱": {
    "id": "前杭爱"
  },
  "安提奥基亚": {
    "id": "安提奥基亚"
  },
  "加什·巴尔卡": {
    "id": "加什·巴尔卡"
  },
  "阿塔科拉": {
    "id": "阿塔科拉"
  },
  "博利瓦尔": {
    "id": "博利瓦尔"
  },
  "伊林加": {
    "id": "伊林加"
  },
  "埃尔梅拉": {
    "id": "埃尔梅拉"
  },
  "磅士卑": {
    "id": "磅士卑"
  },
  "莱塞斯卡尔德－恩戈尔达": {
    "id": "莱塞斯卡尔德－恩戈尔达"
  },
  "巴勒莫": {
    "id": "巴勒莫"
  },
  "托卡特": {
    "id": "托卡特"
  },
  "威拉": {
    "id": "威拉"
  },
  "莫罗纳－圣地亚哥": {
    "id": "莫罗纳－圣地亚哥"
  },
  "巴勒克埃西尔": {
    "id": "巴勒克埃西尔"
  },
  "那不勒斯": {
    "id": "那不勒斯"
  },
  "哈留": {
    "id": "哈留"
  },
  "卡利什": {
    "id": "卡利什"
  },
  "佛蒙特": {
    "id": "佛蒙特"
  },
  "福拉尔贝格": {
    "id": "福拉尔贝格"
  },
  "巴雷": {
    "id": "巴雷"
  },
  "托伦": {
    "id": "托伦"
  },
  "part21": {
    "id": "part21"
  },
  "塔什干": {
    "id": "塔什干"
  },
  "大雅加达首都特区": {
    "id": "大雅加达首都特区"
  },
  "哈马": {
    "id": "哈马"
  },
  "波默伦-苏佩纳姆": {
    "id": "波默伦-苏佩纳姆"
  },
  "加夫萨": {
    "id": "加夫萨"
  },
  "阿尔汉格尔斯克": {
    "id": "阿尔汉格尔斯克"
  },
  "海德马克": {
    "id": "海德马克"
  },
  "莱索托": {
    "id": "莱索托"
  },
  "穆拉姆维亚": {
    "id": "穆拉姆维亚"
  },
  "诺格拉德": {
    "id": "诺格拉德"
  },
  "圣胡安": {
    "id": "圣胡安"
  },
  "阿吉隆": {
    "id": "阿吉隆"
  },
  "滨海皮尼亚尔": {
    "id": "滨海皮尼亚尔"
  },
  "林巴济": {
    "id": "林巴济"
  },
  "博凯": {
    "id": "博凯"
  },
  "沃洛格达": {
    "id": "沃洛格达"
  },
  "基劳纳": {
    "id": "基劳纳"
  },
  "克罗地亚": {
    "id": "克罗地亚"
  },
  "切尔克斯克": {
    "id": "切尔克斯克"
  },
  "英国": {
    "id": "英国"
  },
  "马萨诸塞": {
    "id": "马萨诸塞"
  },
  "特尔戈维什泰": {
    "id": "特尔戈维什泰"
  },
  "海州": {
    "id": "海州"
  },
  "萨卡巴": {
    "id": "萨卡巴"
  },
  "梅德宁": {
    "id": "梅德宁"
  },
  "库德姆卡尔": {
    "id": "库德姆卡尔"
  },
  "威斯康星": {
    "id": "威斯康星"
  },
  "特拉华": {
    "id": "特拉华"
  },
  "加奥": {
    "id": "加奥"
  },
  "科尔达": {
    "id": "科尔达"
  },
  "马六甲": {
    "id": "马六甲"
  },
  "南里奥格兰德": {
    "id": "南里奥格兰德"
  },
  "纳卡皮里皮里特": {
    "id": "纳卡皮里皮里特"
  },
  "皮特凯恩": {
    "id": "皮特凯恩"
  },
  "通贝斯": {
    "id": "通贝斯"
  },
  "奥斯塔": {
    "id": "奥斯塔"
  },
  "外阿彭策尔": {
    "id": "外阿彭策尔"
  },
  "土库曼斯坦": {
    "id": "土库曼斯坦"
  },
  "西北": {
    "id": "西北"
  },
  "萨兰斯克": {
    "id": "萨兰斯克"
  },
  "南迪": {
    "id": "南迪"
  },
  "爱尔福特": {
    "id": "爱尔福特"
  },
  "爱知": {
    "id": "爱知"
  },
  "伊利齐": {
    "id": "伊利齐"
  },
  "爱沙尼亚": {
    "id": "爱沙尼亚"
  },
  "撒马尔罕": {
    "id": "撒马尔罕"
  },
  "考纳斯": {
    "id": "考纳斯"
  },
  "莫纳加斯": {
    "id": "莫纳加斯"
  },
  "罗马尼亚": {
    "id": "罗马尼亚"
  },
  "维克克": {
    "id": "维克克"
  },
  "萨卡特卡斯": {
    "id": "萨卡特卡斯"
  },
  "惠山": {
    "id": "惠山"
  },
  "圣文森特和格林纳丁斯": {
    "id": "圣文森特和格林纳丁斯"
  },
  "斯图加特": {
    "id": "斯图加特"
  },
  "喀土穆": {
    "id": "喀土穆"
  },
  "弗罗茨瓦夫": {
    "id": "弗罗茨瓦夫"
  },
  "赫拉德茨-克拉洛韦": {
    "id": "赫拉德茨-克拉洛韦"
  },
  "瓦利斯和福图纳": {
    "id": "瓦利斯和福图纳"
  },
  "塔夸伦博": {
    "id": "塔夸伦博"
  },
  "卡瓦尼亚斯": {
    "id": "卡瓦尼亚斯"
  },
  "叻丕": {
    "id": "叻丕"
  },
  "麦地那": {
    "id": "麦地那"
  },
  "西南": {
    "id": "西南"
  },
  "萨摩亚": {
    "id": "萨摩亚"
  },
  "冈山": {
    "id": "冈山"
  },
  "沙敦": {
    "id": "沙敦"
  },
  "利耶帕亚": {
    "id": "利耶帕亚"
  },
  "马拉蒂亚": {
    "id": "马拉蒂亚"
  },
  "特里斯坦达昆哈": {
    "id": "特里斯坦达昆哈"
  },
  "中部区": {
    "id": "中部区"
  },
  "三河城": {
    "id": "三河城"
  },
  "瓦姆": {
    "id": "瓦姆"
  },
  "胡利亚卡": {
    "id": "胡利亚卡"
  },
  "科特迪瓦": {
    "id": "科特迪瓦"
  },
  "故吉软瓦拉": {
    "id": "故吉软瓦拉"
  },
  "苏克·阿赫拉斯": {
    "id": "苏克·阿赫拉斯"
  },
  "杰卡布皮尔斯": {
    "id": "杰卡布皮尔斯"
  },
  "尖竹汶": {
    "id": "尖竹汶"
  },
  "圣保罗": {
    "id": "圣保罗"
  },
  "卡门": {
    "id": "卡门"
  },
  "马拉迪": {
    "id": "马拉迪"
  },
  "巴彦乌勒盖": {
    "id": "巴彦乌勒盖"
  },
  "奥沙瓦": {
    "id": "奥沙瓦"
  },
  "阿雅克修": {
    "id": "阿雅克修"
  },
  "纽卡斯尔": {
    "id": "纽卡斯尔"
  },
  "密拉": {
    "id": "密拉"
  },
  "塞蒂": {
    "id": "塞蒂"
  },
  "蒂巴扎": {
    "id": "蒂巴扎"
  },
  "山地": {
    "id": "山地"
  },
  "萨拉热窝": {
    "id": "萨拉热窝"
  },
  "尼日尔": {
    "id": "尼日尔"
  },
  "菲什敦": {
    "id": "菲什敦"
  },
  "乍得": {
    "id": "乍得"
  },
  "part22": {
    "id": "part22"
  },
  "沃特福德": {
    "id": "沃特福德"
  },
  "滨海奥果韦": {
    "id": "滨海奥果韦"
  },
  "拉卡伊": {
    "id": "拉卡伊"
  },
  "维捷布斯克": {
    "id": "维捷布斯克"
  },
  "格拉鲁斯": {
    "id": "格拉鲁斯"
  },
  "阿劳卡尼亚大区": {
    "id": "阿劳卡尼亚大区"
  },
  "萨萨里": {
    "id": "萨萨里"
  },
  "鄂木斯克": {
    "id": "鄂木斯克"
  },
  "阿萨巴": {
    "id": "阿萨巴"
  },
  "布拉索夫": {
    "id": "布拉索夫"
  },
  "下科托": {
    "id": "下科托"
  },
  "锡尔纳克": {
    "id": "锡尔纳克"
  },
  "布琼布拉城市": {
    "id": "布琼布拉城市"
  },
  "圣凯瑟琳": {
    "id": "圣凯瑟琳"
  },
  "克拉古涅瓦茨": {
    "id": "克拉古涅瓦茨"
  },
  "尼代": {
    "id": "尼代"
  },
  "磅湛": {
    "id": "磅湛"
  },
  "密苏里": {
    "id": "密苏里"
  },
  "恩加": {
    "id": "恩加"
  },
  "拉塔基亚": {
    "id": "拉塔基亚"
  },
  "利斯滕堡": {
    "id": "利斯滕堡"
  },
  "哈达普": {
    "id": "哈达普"
  },
  "甲米": {
    "id": "甲米"
  },
  "苏姆": {
    "id": "苏姆"
  },
  "普里什蒂纳": {
    "id": "普里什蒂纳"
  },
  "中央": {
    "id": "中央"
  },
  "特莱姆森": {
    "id": "特莱姆森"
  },
  "彭纳马": {
    "id": "彭纳马"
  },
  "维尔茨堡": {
    "id": "维尔茨堡"
  },
  "尼什": {
    "id": "尼什"
  },
  "库埃纳瓦卡": {
    "id": "库埃纳瓦卡"
  },
  "夸勒": {
    "id": "夸勒"
  },
  "阿卡普尔科": {
    "id": "阿卡普尔科"
  },
  "姆皮吉": {
    "id": "姆皮吉"
  },
  "艾利弗山": {
    "id": "艾利弗山"
  },
  "安斯巴格": {
    "id": "安斯巴格"
  },
  "比罗比詹": {
    "id": "比罗比詹"
  },
  "吉塔拉马": {
    "id": "吉塔拉马"
  },
  "特皮克": {
    "id": "特皮克"
  },
  "莱格尼察": {
    "id": "莱格尼察"
  },
  "托罗罗": {
    "id": "托罗罗"
  },
  "厄勒布鲁": {
    "id": "厄勒布鲁"
  },
  "莫斯科": {
    "id": "莫斯科"
  },
  "鲁汉戈": {
    "id": "鲁汉戈"
  },
  "奥尔什丁": {
    "id": "奥尔什丁"
  },
  "滋贺": {
    "id": "滋贺"
  },
  "罗斯基勒": {
    "id": "罗斯基勒"
  },
  "哥得兰": {
    "id": "哥得兰"
  },
  "上丁": {
    "id": "上丁"
  },
  "亚的斯亚贝巴": {
    "id": "亚的斯亚贝巴"
  },
  "达希莱地区": {
    "id": "达希莱地区"
  },
  "伊奥巴": {
    "id": "伊奥巴"
  },
  "兰茨胡特": {
    "id": "兰茨胡特"
  },
  "坎帕拉": {
    "id": "坎帕拉"
  },
  "卢旺达": {
    "id": "卢旺达"
  },
  "津巴布韦": {
    "id": "津巴布韦"
  },
  "沙湾拿吉": {
    "id": "沙湾拿吉"
  },
  "卡耶亚多": {
    "id": "卡耶亚多"
  },
  "基布耶": {
    "id": "基布耶"
  },
  "赞比亚": {
    "id": "赞比亚"
  },
  "迈科普": {
    "id": "迈科普"
  },
  "库尔斯克": {
    "id": "库尔斯克"
  },
  "卡尔达斯": {
    "id": "卡尔达斯"
  },
  "科尔多巴": {
    "id": "科尔多巴"
  },
  "巴真": {
    "id": "巴真"
  },
  "福古岛": {
    "id": "福古岛"
  },
  "贾纳克布尔": {
    "id": "贾纳克布尔"
  },
  "塞尔维亚,黑山": {
    "id": "塞尔维亚,黑山"
  },
  "甘烹碧": {
    "id": "甘烹碧"
  },
  "萨拉托夫": {
    "id": "萨拉托夫"
  },
  "西哈萨克斯坦": {
    "id": "西哈萨克斯坦"
  },
  "巴利城": {
    "id": "巴利城"
  },
  "瓦尔米耶拉": {
    "id": "瓦尔米耶拉"
  },
  "利佩茨克": {
    "id": "利佩茨克"
  },
  "奥巴尔诺-克拉": {
    "id": "奥巴尔诺-克拉"
  },
  "卡拉巴尔塔": {
    "id": "卡拉巴尔塔"
  },
  "津德尔": {
    "id": "津德尔"
  },
  "莫桑比克": {
    "id": "莫桑比克"
  },
  "吉林省": {
    "id": "吉林省"
  },
  "梅基卡诺斯": {
    "id": "梅基卡诺斯"
  },
  "奥科特佩克": {
    "id": "奥科特佩克"
  },
  "卡塔尔": {
    "id": "卡塔尔"
  },
  "弗雷堡": {
    "id": "弗雷堡"
  },
  "索洛图恩": {
    "id": "索洛图恩"
  },
  "里亚内": {
    "id": "里亚内"
  },
  "迪勃拉": {
    "id": "迪勃拉"
  },
  "基雅尼": {
    "id": "基雅尼"
  },
  "切尔尼戈夫": {
    "id": "切尔尼戈夫"
  },
  "阿巴坎": {
    "id": "阿巴坎"
  },
  "卡拉曼": {
    "id": "卡拉曼"
  },
  "圣詹姆斯": {
    "id": "圣詹姆斯"
  },
  "乌拉秋别": {
    "id": "乌拉秋别"
  },
  "瓜希拉": {
    "id": "瓜希拉"
  },
  "安道尔": {
    "id": "安道尔"
  },
  "埃斯波": {
    "id": "埃斯波"
  },
  "塞梅伊": {
    "id": "塞梅伊"
  },
  "比勒费尔德": {
    "id": "比勒费尔德"
  },
  "比特利斯": {
    "id": "比特利斯"
  },
  "part23": {
    "id": "part23"
  },
  "弗赖堡": {
    "id": "弗赖堡"
  },
  "恩济－科莫埃": {
    "id": "恩济－科莫埃"
  },
  "蒙扎": {
    "id": "蒙扎"
  },
  "韦拉克鲁斯": {
    "id": "韦拉克鲁斯"
  },
  "匈牙利": {
    "id": "匈牙利"
  },
  "哈塔伊": {
    "id": "哈塔伊"
  },
  "巴吞他尼": {
    "id": "巴吞他尼"
  },
  "圣皮埃尔和米克隆群岛": {
    "id": "圣皮埃尔和米克隆群岛"
  },
  "巴基斯坦": {
    "id": "巴基斯坦"
  },
  "穆里斯堡": {
    "id": "穆里斯堡"
  },
  "摩拉维亚-西里西亚": {
    "id": "摩拉维亚-西里西亚"
  },
  "特雷利乌": {
    "id": "特雷利乌"
  },
  "韦韦特南戈": {
    "id": "韦韦特南戈"
  },
  "山西省": {
    "id": "山西省"
  },
  "库斯科": {
    "id": "库斯科"
  },
  "莫讷勒格勒": {
    "id": "莫讷勒格勒"
  },
  "祖": {
    "id": "祖"
  },
  "内地地区": {
    "id": "内地地区"
  },
  "圣地亚哥岛": {
    "id": "圣地亚哥岛"
  },
  "福阿穆拉库": {
    "id": "福阿穆拉库"
  },
  "菲茵": {
    "id": "菲茵"
  },
  "康塞普西翁": {
    "id": "康塞普西翁"
  },
  "特克斯和凯克特斯群岛": {
    "id": "特克斯和凯克特斯群岛"
  },
  "格恩西岛": {
    "id": "格恩西岛"
  },
  "科潘": {
    "id": "科潘"
  },
  "马萨": {
    "id": "马萨"
  },
  "北部": {
    "id": "北部"
  },
  "格拉西亚斯-阿迪奥斯": {
    "id": "格拉西亚斯-阿迪奥斯"
  },
  "南极洲": {
    "id": "南极洲"
  },
  "约兹加特": {
    "id": "约兹加特"
  },
  "跳羚": {
    "id": "跳羚"
  },
  "布莱金厄": {
    "id": "布莱金厄"
  },
  "科布伦次": {
    "id": "科布伦次"
  },
  "舍布鲁克": {
    "id": "舍布鲁克"
  },
  "拉瓦耶哈": {
    "id": "拉瓦耶哈"
  },
  "马萨布布": {
    "id": "马萨布布"
  },
  "马德里斯": {
    "id": "马德里斯"
  },
  "乞力马扎罗": {
    "id": "乞力马扎罗"
  },
  "苏拉纳": {
    "id": "苏拉纳"
  },
  "基本古": {
    "id": "基本古"
  },
  "赫拉特": {
    "id": "赫拉特"
  },
  "济金绍尔": {
    "id": "济金绍尔"
  },
  "波斯尼亚－波德里涅": {
    "id": "波斯尼亚－波德里涅"
  },
  "塔尔诺布热格": {
    "id": "塔尔诺布热格"
  },
  "涅比特达格": {
    "id": "涅比特达格"
  },
  "尼克里": {
    "id": "尼克里"
  },
  "梅地奥特茹": {
    "id": "梅地奥特茹"
  },
  "阿德亚曼": {
    "id": "阿德亚曼"
  },
  "中国": {
    "id": "中国"
  },
  "曼彻斯特": {
    "id": "曼彻斯特"
  },
  "兹林": {
    "id": "兹林"
  },
  "帕斯塔萨": {
    "id": "帕斯塔萨"
  },
  "宽多库邦戈": {
    "id": "宽多库邦戈"
  },
  "巴巴多斯岛": {
    "id": "巴巴多斯岛"
  },
  "爱荷华": {
    "id": "爱荷华"
  },
  "奥布阿西": {
    "id": "奥布阿西"
  },
  "圣尼古拉斯": {
    "id": "圣尼古拉斯"
  },
  "蒙特塞拉特": {
    "id": "蒙特塞拉特"
  },
  "奔萨": {
    "id": "奔萨"
  },
  "甘贝拉各族": {
    "id": "甘贝拉各族"
  },
  "西帕里韦尼": {
    "id": "西帕里韦尼"
  },
  "哈塞克": {
    "id": "哈塞克"
  },
  "内格罗河": {
    "id": "内格罗河"
  },
  "耶莱尼亚古拉": {
    "id": "耶莱尼亚古拉"
  },
  "康康": {
    "id": "康康"
  },
  "北特伦德拉格": {
    "id": "北特伦德拉格"
  },
  "斯凯尔涅维采": {
    "id": "斯凯尔涅维采"
  },
  "哥伦比亚特区": {
    "id": "哥伦比亚特区"
  },
  "韦尔科姆": {
    "id": "韦尔科姆"
  },
  "巴利亚多利德": {
    "id": "巴利亚多利德"
  },
  "西福尔": {
    "id": "西福尔"
  },
  "佛得角": {
    "id": "佛得角"
  },
  "钦邦": {
    "id": "钦邦"
  },
  "西岸": {
    "id": "西岸"
  },
  "特尔纳瓦": {
    "id": "特尔纳瓦"
  },
  "阿波帕": {
    "id": "阿波帕"
  },
  "卡内洛内斯": {
    "id": "卡内洛内斯"
  },
  "伊斯帕尔塔": {
    "id": "伊斯帕尔塔"
  },
  "塞罗拉尔戈": {
    "id": "塞罗拉尔戈"
  },
  "巴姆": {
    "id": "巴姆"
  },
  "华盛顿": {
    "id": "华盛顿"
  },
  "堪培拉": {
    "id": "堪培拉"
  },
  "哈利法克斯": {
    "id": "哈利法克斯"
  },
  "巴尔腾": {
    "id": "巴尔腾"
  },
  "布基纳法索": {
    "id": "布基纳法索"
  },
  "托卢卡": {
    "id": "托卢卡"
  },
  "马尼卡兰": {
    "id": "马尼卡兰"
  },
  "安托法加斯塔大区": {
    "id": "安托法加斯塔大区"
  },
  "杰尔-莫松-肖普朗": {
    "id": "杰尔-莫松-肖普朗"
  },
  "几内亚": {
    "id": "几内亚"
  },
  "克拉约瓦": {
    "id": "克拉约瓦"
  },
  "达喀尔": {
    "id": "达喀尔"
  },
  "比那尔德里奥": {
    "id": "比那尔德里奥"
  },
  "吉孔戈罗": {
    "id": "吉孔戈罗"
  },
  "楚河": {
    "id": "楚河"
  },
  "雷西姆农": {
    "id": "雷西姆农"
  },
  "留尼旺岛": {
    "id": "留尼旺岛"
  },
  "东福尔": {
    "id": "东福尔"
  },
  "part24": {
    "id": "part24"
  },
  "里伯": {
    "id": "里伯"
  },
  "沃佩斯": {
    "id": "沃佩斯"
  },
  "亚丁": {
    "id": "亚丁"
  },
  "雷恩": {
    "id": "雷恩"
  },
  "安纳巴": {
    "id": "安纳巴"
  },
  "埃尔格约-马拉奎特": {
    "id": "埃尔格约-马拉奎特"
  },
  "上科托": {
    "id": "上科托"
  },
  "特尔古穆列什": {
    "id": "特尔古穆列什"
  },
  "洛哈": {
    "id": "洛哈"
  },
  "大马士革市": {
    "id": "大马士革市"
  },
  "波热加-斯拉沃尼亚": {
    "id": "波热加-斯拉沃尼亚"
  },
  "利默里克": {
    "id": "利默里克"
  },
  "科普里夫尼察-克里热夫齐": {
    "id": "科普里夫尼察-克里热夫齐"
  },
  "斯摩棱斯克": {
    "id": "斯摩棱斯克"
  },
  "塞内加尔": {
    "id": "塞内加尔"
  },
  "釜山": {
    "id": "釜山"
  },
  "包尔绍德-奥包乌伊-曾普伦": {
    "id": "包尔绍德-奥包乌伊-曾普伦"
  },
  "恩塞纳达": {
    "id": "恩塞纳达"
  },
  "芬马克": {
    "id": "芬马克"
  },
  "延雪平": {
    "id": "延雪平"
  },
  "萨斯卡通": {
    "id": "萨斯卡通"
  },
  "阿布歇隆": {
    "id": "阿布歇隆"
  },
  "喀麦隆": {
    "id": "喀麦隆"
  },
  "马圭省": {
    "id": "马圭省"
  },
  "拉科鲁尼亚": {
    "id": "拉科鲁尼亚"
  },
  "花拉子模": {
    "id": "花拉子模"
  },
  "邦戈马": {
    "id": "邦戈马"
  },
  "荷台达": {
    "id": "荷台达"
  },
  "南加里曼丹": {
    "id": "南加里曼丹"
  },
  "灵克宾": {
    "id": "灵克宾"
  },
  "安特卫普": {
    "id": "安特卫普"
  },
  "穆什": {
    "id": "穆什"
  },
  "努雷克": {
    "id": "努雷克"
  },
  "基里菲": {
    "id": "基里菲"
  },
  "亚历山大": {
    "id": "亚历山大"
  },
  "卢阿普拉": {
    "id": "卢阿普拉"
  },
  "达拉纳": {
    "id": "达拉纳"
  },
  "戈亚斯": {
    "id": "戈亚斯"
  },
  "布林迪西": {
    "id": "布林迪西"
  },
  "戈壁阿尔泰": {
    "id": "戈壁阿尔泰"
  },
  "马罗韦讷": {
    "id": "马罗韦讷"
  },
  "加里萨": {
    "id": "加里萨"
  },
  "穆科诺": {
    "id": "穆科诺"
  },
  "南苏拉威西": {
    "id": "南苏拉威西"
  },
  "宾香古尔": {
    "id": "宾香古尔"
  },
  "卢布林": {
    "id": "卢布林"
  },
  "朱拜勒": {
    "id": "朱拜勒"
  },
  "马努巴": {
    "id": "马努巴"
  },
  "赞赞": {
    "id": "赞赞"
  },
  "萨姆松": {
    "id": "萨姆松"
  },
  "耶姆特兰": {
    "id": "耶姆特兰"
  },
  "赫梅利尼茨基": {
    "id": "赫梅利尼茨基"
  },
  "比尔森": {
    "id": "比尔森"
  },
  "纳阿马": {
    "id": "纳阿马"
  },
  "丘基萨卡": {
    "id": "丘基萨卡"
  },
  "沃罗杜古": {
    "id": "沃罗杜古"
  },
  "苏尔汉河": {
    "id": "苏尔汉河"
  },
  "特尔希艾": {
    "id": "特尔希艾"
  },
  "萨瓦纳": {
    "id": "萨瓦纳"
  },
  "磅清扬": {
    "id": "磅清扬"
  },
  "铁克利": {
    "id": "铁克利"
  },
  "墨西拿": {
    "id": "墨西拿"
  },
  "卢森堡": {
    "id": "卢森堡"
  },
  "京都": {
    "id": "京都"
  },
  "布赖代": {
    "id": "布赖代"
  },
  "海牙": {
    "id": "海牙"
  },
  "乌干达": {
    "id": "乌干达"
  },
  "圣卢西亚": {
    "id": "圣卢西亚"
  },
  "卡瓦多": {
    "id": "卡瓦多"
  },
  "依达－维鲁": {
    "id": "依达－维鲁"
  },
  "格罗兹尼": {
    "id": "格罗兹尼"
  },
  "托尔瑙": {
    "id": "托尔瑙"
  },
  "内皮尼亚尔南": {
    "id": "内皮尼亚尔南"
  },
  "格鲁琼兹": {
    "id": "格鲁琼兹"
  },
  "古韦里耶": {
    "id": "古韦里耶"
  },
  "韦姆兰": {
    "id": "韦姆兰"
  },
  "伊切尔": {
    "id": "伊切尔"
  },
  "锡尔特": {
    "id": "锡尔特"
  },
  "新墨西哥": {
    "id": "新墨西哥"
  },
  "泰塔塔维塔": {
    "id": "泰塔塔维塔"
  },
  "科洛": {
    "id": "科洛"
  },
  "特切": {
    "id": "特切"
  },
  "基拉科洛": {
    "id": "基拉科洛"
  },
  "恩斯赫德": {
    "id": "恩斯赫德"
  },
  "谢拉兹": {
    "id": "谢拉兹"
  },
  "杰兹卡兹甘": {
    "id": "杰兹卡兹甘"
  },
  "马尔丁": {
    "id": "马尔丁"
  },
  "默勒－鲁姆斯达尔": {
    "id": "默勒－鲁姆斯达尔"
  },
  "毛里塔尼亚": {
    "id": "毛里塔尼亚"
  },
  "科迪勒拉": {
    "id": "科迪勒拉"
  },
  "法罗群岛": {
    "id": "法罗群岛"
  },
  "新潟": {
    "id": "新潟"
  },
  "内皮尼亚尔北": {
    "id": "内皮尼亚尔北"
  },
  "巴尔瑙尔": {
    "id": "巴尔瑙尔"
  },
  "塞舌尔": {
    "id": "塞舌尔"
  },
  "比萨": {
    "id": "比萨"
  },
  "切图马尔": {
    "id": "切图马尔"
  },
  "波罗勉": {
    "id": "波罗勉"
  },
  "武科瓦尔-斯里耶姆": {
    "id": "武科瓦尔-斯里耶姆"
  },
  "胡胡伊": {
    "id": "胡胡伊"
  },
  "赫维什": {
    "id": "赫维什"
  },
  "part25": {
    "id": "part25"
  },
  "明尼苏达": {
    "id": "明尼苏达"
  },
  "京畿道": {
    "id": "京畿道"
  },
  "那慕尔": {
    "id": "那慕尔"
  },
  "卡亚俄": {
    "id": "卡亚俄"
  },
  "圣格奥尔基": {
    "id": "圣格奥尔基"
  },
  "里奥夸尔托": {
    "id": "里奥夸尔托"
  },
  "别尔哥罗德": {
    "id": "别尔哥罗德"
  },
  "博美特": {
    "id": "博美特"
  },
  "加的斯": {
    "id": "加的斯"
  },
  "萨图帕伊泰阿": {
    "id": "萨图帕伊泰阿"
  },
  "奥博莫绍": {
    "id": "奥博莫绍"
  },
  "博阿科": {
    "id": "博阿科"
  },
  "新普利茅斯": {
    "id": "新普利茅斯"
  },
  "以色列": {
    "id": "以色列"
  },
  "拉多姆": {
    "id": "拉多姆"
  },
  "佛统": {
    "id": "佛统"
  },
  "卡拉卡尔帕克斯坦共和国": {
    "id": "卡拉卡尔帕克斯坦共和国"
  },
  "兵库": {
    "id": "兵库"
  },
  "阿斯旺": {
    "id": "阿斯旺"
  },
  "博卢": {
    "id": "博卢"
  },
  "巴塞罗那": {
    "id": "巴塞罗那"
  },
  "也拉": {
    "id": "也拉"
  },
  "安齐拉纳纳": {
    "id": "安齐拉纳纳"
  },
  "库尔恰托夫": {
    "id": "库尔恰托夫"
  },
  "里泽": {
    "id": "里泽"
  },
  "卡尔斯鲁厄": {
    "id": "卡尔斯鲁厄"
  },
  "基里巴斯": {
    "id": "基里巴斯"
  },
  "西波斯尼亚": {
    "id": "西波斯尼亚"
  },
  "坦佩雷": {
    "id": "坦佩雷"
  },
  "色楞格": {
    "id": "色楞格"
  },
  "奥伦堡": {
    "id": "奥伦堡"
  },
  "马那瓜": {
    "id": "马那瓜"
  },
  "贝达": {
    "id": "贝达"
  },
  "佐特尔梅": {
    "id": "佐特尔梅"
  },
  "哈雷": {
    "id": "哈雷"
  },
  "占碑": {
    "id": "占碑"
  },
  "韦梅": {
    "id": "韦梅"
  },
  "华雷斯": {
    "id": "华雷斯"
  },
  "皮亚特拉尼亚姆茨": {
    "id": "皮亚特拉尼亚姆茨"
  },
  "泽西岛": {
    "id": "泽西岛"
  },
  "密尔-卡拉巴赫": {
    "id": "密尔-卡拉巴赫"
  },
  "尼加拉瓜": {
    "id": "尼加拉瓜"
  },
  "布良斯克": {
    "id": "布良斯克"
  },
  "卡里加里": {
    "id": "卡里加里"
  },
  "坎库佐": {
    "id": "坎库佐"
  },
  "多雷尼": {
    "id": "多雷尼"
  },
  "布列塔尼角": {
    "id": "布列塔尼角"
  },
  "特拉维夫": {
    "id": "特拉维夫"
  },
  "锡比托凯": {
    "id": "锡比托凯"
  },
  "开姆尼斯": {
    "id": "开姆尼斯"
  },
  "塔波阿": {
    "id": "塔波阿"
  },
  "基辅": {
    "id": "基辅"
  },
  "卡鲁济": {
    "id": "卡鲁济"
  },
  "帕尔马": {
    "id": "帕尔马"
  },
  "安圭拉": {
    "id": "安圭拉"
  },
  "艾因·德夫拉": {
    "id": "艾因·德夫拉"
  },
  "猜那": {
    "id": "猜那"
  },
  "洛坤": {
    "id": "洛坤"
  },
  "尼古拉耶夫": {
    "id": "尼古拉耶夫"
  },
  "韦克斯福德": {
    "id": "韦克斯福德"
  },
  "莱什诺": {
    "id": "莱什诺"
  },
  "大吉德": {
    "id": "大吉德"
  },
  "森伯尔布尔": {
    "id": "森伯尔布尔"
  },
  "柏威夏": {
    "id": "柏威夏"
  },
  "怀塔科拉": {
    "id": "怀塔科拉"
  },
  "图尔高": {
    "id": "图尔高"
  },
  "西部高地": {
    "id": "西部高地"
  },
  "塔瓦": {
    "id": "塔瓦"
  },
  "苏韦达": {
    "id": "苏韦达"
  },
  "伯里亚": {
    "id": "伯里亚"
  },
  "枥木": {
    "id": "枥木"
  },
  "托利马": {
    "id": "托利马"
  },
  "林堡": {
    "id": "林堡"
  },
  "阿拉德": {
    "id": "阿拉德"
  },
  "崂斯": {
    "id": "崂斯"
  },
  "泽蒙": {
    "id": "泽蒙"
  },
  "厄瓜多尔": {
    "id": "厄瓜多尔"
  },
  "克勒克卡莱": {
    "id": "克勒克卡莱"
  },
  "亚滕加": {
    "id": "亚滕加"
  },
  "雷拉巴": {
    "id": "雷拉巴"
  },
  "扎伊尔": {
    "id": "扎伊尔"
  },
  "苏姆盖特": {
    "id": "苏姆盖特"
  },
  "瓦尔帕莱索大区": {
    "id": "瓦尔帕莱索大区"
  },
  "阿特劳": {
    "id": "阿特劳"
  },
  "特罗姆斯": {
    "id": "特罗姆斯"
  },
  "奥斯特罗文卡": {
    "id": "奥斯特罗文卡"
  },
  "犹他": {
    "id": "犹他"
  },
  "科泰克": {
    "id": "科泰克"
  },
  "托木斯克": {
    "id": "托木斯克"
  },
  "科洛尼亚": {
    "id": "科洛尼亚"
  },
  "克拉斯诺亚尔斯克": {
    "id": "克拉斯诺亚尔斯克"
  },
  "斯捷普诺戈尔斯克": {
    "id": "斯捷普诺戈尔斯克"
  },
  "彼德斯堡": {
    "id": "彼德斯堡"
  },
  "博亚卡": {
    "id": "博亚卡"
  },
  "哈奇马斯": {
    "id": "哈奇马斯"
  },
  "汉诺威": {
    "id": "汉诺威"
  },
  "圣巴巴拉": {
    "id": "圣巴巴拉"
  },
  "洛巴伊": {
    "id": "洛巴伊"
  },
  "扎勒乌": {
    "id": "扎勒乌"
  },
  "part26": {
    "id": "part26"
  },
  "瓦奥福诺蒂": {
    "id": "瓦奥福诺蒂"
  },
  "伊瓦涅斯将军的艾森大区": {
    "id": "伊瓦涅斯将军的艾森大区"
  },
  "埃诺": {
    "id": "埃诺"
  },
  "塔拉斯": {
    "id": "塔拉斯"
  },
  "韦斯卡": {
    "id": "韦斯卡"
  },
  "圣埃斯皮里图": {
    "id": "圣埃斯皮里图"
  },
  "圣米戈尔": {
    "id": "圣米戈尔"
  },
  "台湾省": {
    "id": "台湾省"
  },
  "朝鲜": {
    "id": "朝鲜"
  },
  "姆西拉": {
    "id": "姆西拉"
  },
  "巴伦西亚": {
    "id": "巴伦西亚"
  },
  "阿拉胡埃拉": {
    "id": "阿拉胡埃拉"
  },
  "不伦瑞克": {
    "id": "不伦瑞克"
  },
  "乔伊索": {
    "id": "乔伊索"
  },
  "丰沙里": {
    "id": "丰沙里"
  },
  "卡塔戈": {
    "id": "卡塔戈"
  },
  "塔尔努夫": {
    "id": "塔尔努夫"
  },
  "素可泰": {
    "id": "素可泰"
  },
  "费里": {
    "id": "费里"
  },
  "南摩拉维亚": {
    "id": "南摩拉维亚"
  },
  "巴利阿里": {
    "id": "巴利阿里"
  },
  "阿利图斯": {
    "id": "阿利图斯"
  },
  "安科纳": {
    "id": "安科纳"
  },
  "查拉特南戈": {
    "id": "查拉特南戈"
  },
  "亚克曼": {
    "id": "亚克曼"
  },
  "金斯敦": {
    "id": "金斯敦"
  },
  "加沙地带": {
    "id": "加沙地带"
  },
  "圣菲": {
    "id": "圣菲"
  },
  "东部": {
    "id": "东部"
  },
  "布隆迪": {
    "id": "布隆迪"
  },
  "法迪福卢": {
    "id": "法迪福卢"
  },
  "卡夫": {
    "id": "卡夫"
  },
  "济良诺夫斯克": {
    "id": "济良诺夫斯克"
  },
  "佛兰芒-布拉班特": {
    "id": "佛兰芒-布拉班特"
  },
  "蒙大拿": {
    "id": "蒙大拿"
  },
  "赛文": {
    "id": "赛文"
  },
  "图尔孙扎德": {
    "id": "图尔孙扎德"
  },
  "科摩罗": {
    "id": "科摩罗"
  },
  "梵蒂冈": {
    "id": "梵蒂冈"
  },
  "库尤尼-马扎鲁尼": {
    "id": "库尤尼-马扎鲁尼"
  },
  "伊塞尔尼亚": {
    "id": "伊塞尔尼亚"
  },
  "加查斯内克": {
    "id": "加查斯内克"
  },
  "奇基穆拉": {
    "id": "奇基穆拉"
  },
  "上东部": {
    "id": "上东部"
  },
  "罗卢姆": {
    "id": "罗卢姆"
  },
  "阿尔及利亚": {
    "id": "阿尔及利亚"
  },
  "康斯坦察": {
    "id": "康斯坦察"
  },
  "莱利斯塔德": {
    "id": "莱利斯塔德"
  },
  "克勒拉希": {
    "id": "克勒拉希"
  },
  "恩布": {
    "id": "恩布"
  },
  "吉兰丹": {
    "id": "吉兰丹"
  },
  "西班牙": {
    "id": "西班牙"
  },
  "新喀里多尼亚": {
    "id": "新喀里多尼亚"
  },
  "博米": {
    "id": "博米"
  },
  "巴泽加": {
    "id": "巴泽加"
  },
  "巴彦洪格尔": {
    "id": "巴彦洪格尔"
  },
  "卡布加": {
    "id": "卡布加"
  },
  "乔鲁姆": {
    "id": "乔鲁姆"
  },
  "普雷绍夫": {
    "id": "普雷绍夫"
  },
  "上西部": {
    "id": "上西部"
  },
  "明斯克市": {
    "id": "明斯克市"
  },
  "吉尔吉斯斯坦": {
    "id": "吉尔吉斯斯坦"
  },
  "多多马": {
    "id": "多多马"
  },
  "尼斯": {
    "id": "尼斯"
  },
  "比斯克拉": {
    "id": "比斯克拉"
  },
  "古巴": {
    "id": "古巴"
  },
  "塞哥维亚": {
    "id": "塞哥维亚"
  },
  "卡贝拉马伊多": {
    "id": "卡贝拉马伊多"
  },
  "广岛": {
    "id": "广岛"
  },
  "上塔库图-上埃塞奎博": {
    "id": "上塔库图-上埃塞奎博"
  },
  "泰国": {
    "id": "泰国"
  },
  "卡拉沃沃": {
    "id": "卡拉沃沃"
  },
  "北达科他": {
    "id": "北达科他"
  },
  "邦加－勿里洞群岛": {
    "id": "邦加－勿里洞群岛"
  },
  "沙捞越": {
    "id": "沙捞越"
  },
  "维索基纳": {
    "id": "维索基纳"
  },
  "贝鲁特": {
    "id": "贝鲁特"
  },
  "迈赫维特": {
    "id": "迈赫维特"
  },
  "帕劳群岛": {
    "id": "帕劳群岛"
  },
  "布谢尼": {
    "id": "布谢尼"
  },
  "哈费尔巴廷": {
    "id": "哈费尔巴廷"
  },
  "努瓦克肖特特区": {
    "id": "努瓦克肖特特区"
  },
  "卡马圭": {
    "id": "卡马圭"
  },
  "卡约": {
    "id": "卡约"
  },
  "温莎": {
    "id": "温莎"
  },
  "桑给巴尔": {
    "id": "桑给巴尔"
  },
  "瓦尔加": {
    "id": "瓦尔加"
  },
  "戈尔戈勒": {
    "id": "戈尔戈勒"
  },
  "多内加尔": {
    "id": "多内加尔"
  },
  "海南省": {
    "id": "海南省"
  },
  "拉斯图纳斯": {
    "id": "拉斯图纳斯"
  },
  "英属印度洋领地": {
    "id": "英属印度洋领地"
  },
  "纳戈尔诺－卡拉巴赫": {
    "id": "纳戈尔诺－卡拉巴赫"
  },
  "纳曼干": {
    "id": "纳曼干"
  },
  "洛里": {
    "id": "洛里"
  },
  "四色菊": {
    "id": "四色菊"
  },
  "霍隆": {
    "id": "霍隆"
  },
  "泻湖": {
    "id": "泻湖"
  },
  "纳里尼奥": {
    "id": "纳里尼奥"
  },
  "巴达霍斯": {
    "id": "巴达霍斯"
  },
  "福冈": {
    "id": "福冈"
  },
  "中苏拉威西": {
    "id": "中苏拉威西"
  },
  "沙迦": {
    "id": "沙迦"
  },
  "part27": {
    "id": "part27"
  },
  "克莱佩达": {
    "id": "克莱佩达"
  },
  "贾拉拉巴德": {
    "id": "贾拉拉巴德"
  },
  "博博纳罗": {
    "id": "博博纳罗"
  },
  "莫吉廖夫": {
    "id": "莫吉廖夫"
  },
  "瓦约茨·佐尔": {
    "id": "瓦约茨·佐尔"
  },
  "奥卢": {
    "id": "奥卢"
  },
  "采西斯": {
    "id": "采西斯"
  },
  "西马绍纳兰": {
    "id": "西马绍纳兰"
  },
  "海地": {
    "id": "海地"
  },
  "素叻": {
    "id": "素叻"
  },
  "丁加奴": {
    "id": "丁加奴"
  },
  "智利": {
    "id": "智利"
  },
  "纳闽": {
    "id": "纳闽"
  },
  "比托姆": {
    "id": "比托姆"
  },
  "巴林戈": {
    "id": "巴林戈"
  },
  "夜丰颂": {
    "id": "夜丰颂"
  },
  "马杜赖": {
    "id": "马杜赖"
  },
  "基索罗": {
    "id": "基索罗"
  },
  "长崎": {
    "id": "长崎"
  },
  "北隆达": {
    "id": "北隆达"
  },
  "庆尚北道": {
    "id": "庆尚北道"
  },
  "朗多尼亚": {
    "id": "朗多尼亚"
  },
  "克劳斯城": {
    "id": "克劳斯城"
  },
  "埃塞奎博群岛-西德梅拉拉": {
    "id": "埃塞奎博群岛-西德梅拉拉"
  },
  "乌姆塔塔": {
    "id": "乌姆塔塔"
  },
  "杰拉什": {
    "id": "杰拉什"
  },
  "伊兹密尔": {
    "id": "伊兹密尔"
  },
  "帕劳利": {
    "id": "帕劳利"
  },
  "雅罗斯拉夫尔": {
    "id": "雅罗斯拉夫尔"
  },
  "奥果韦-洛洛": {
    "id": "奥果韦-洛洛"
  },
  "普雷利": {
    "id": "普雷利"
  },
  "森巴布莱": {
    "id": "森巴布莱"
  },
  "安卡什": {
    "id": "安卡什"
  },
  "山东省": {
    "id": "山东省"
  },
  "特里洛尼": {
    "id": "特里洛尼"
  },
  "喀山": {
    "id": "喀山"
  },
  "布迈德斯": {
    "id": "布迈德斯"
  },
  "希维托赫洛维采": {
    "id": "希维托赫洛维采"
  },
  "南方": {
    "id": "南方"
  },
  "代尼兹利": {
    "id": "代尼兹利"
  },
  "威克洛": {
    "id": "威克洛"
  },
  "塔斯马尼亚": {
    "id": "塔斯马尼亚"
  },
  "卡塔尼亚": {
    "id": "卡塔尼亚"
  },
  "维吉尼亚": {
    "id": "维吉尼亚"
  },
  "马腊": {
    "id": "马腊"
  },
  "威尼斯": {
    "id": "威尼斯"
  },
  "中南": {
    "id": "中南"
  },
  "斯海尔托亨博思": {
    "id": "斯海尔托亨博思"
  },
  "塔伊兹": {
    "id": "塔伊兹"
  },
  "瓦卡加": {
    "id": "瓦卡加"
  },
  "马多纳": {
    "id": "马多纳"
  },
  "布拉瓦岛": {
    "id": "布拉瓦岛"
  },
  "纳尔逊": {
    "id": "纳尔逊"
  },
  "雷塔卢莱乌": {
    "id": "雷塔卢莱乌"
  },
  "加勒": {
    "id": "加勒"
  },
  "内阿彭策尔": {
    "id": "内阿彭策尔"
  },
  "尼蒂": {
    "id": "尼蒂"
  },
  "罗恰": {
    "id": "罗恰"
  },
  "托克劳": {
    "id": "托克劳"
  },
  "布雷西亚": {
    "id": "布雷西亚"
  },
  "日本": {
    "id": "日本"
  },
  "龙仔厝": {
    "id": "龙仔厝"
  },
  "联邦属地": {
    "id": "联邦属地"
  },
  "阿布扎比": {
    "id": "阿布扎比"
  },
  "凯尔采": {
    "id": "凯尔采"
  },
  "马拉尼昂": {
    "id": "马拉尼昂"
  },
  "阿普雷": {
    "id": "阿普雷"
  },
  "攀牙": {
    "id": "攀牙"
  },
  "古尔贝内": {
    "id": "古尔贝内"
  },
  "布塔雷": {
    "id": "布塔雷"
  },
  "索里亚": {
    "id": "索里亚"
  },
  "霍伊马": {
    "id": "霍伊马"
  },
  "突厥斯坦": {
    "id": "突厥斯坦"
  },
  "亚美尼亚": {
    "id": "亚美尼亚"
  },
  "欣延加": {
    "id": "欣延加"
  },
  "米兰": {
    "id": "米兰"
  },
  "北大西洋": {
    "id": "北大西洋"
  },
  "帕拉伊巴": {
    "id": "帕拉伊巴"
  },
  "弗洛雷斯": {
    "id": "弗洛雷斯"
  },
  "南卡罗来纳": {
    "id": "南卡罗来纳"
  },
  "阿维拉": {
    "id": "阿维拉"
  },
  "海防": {
    "id": "海防"
  },
  "扎布热": {
    "id": "扎布热"
  },
  "全罗北道": {
    "id": "全罗北道"
  },
  "利卡-塞尼": {
    "id": "利卡-塞尼"
  },
  "奥克兰": {
    "id": "奥克兰"
  },
  "哈尔科夫": {
    "id": "哈尔科夫"
  },
  "布拉班特-瓦隆": {
    "id": "布拉班特-瓦隆"
  },
  "德绍": {
    "id": "德绍"
  },
  "诺福克": {
    "id": "诺福克"
  },
  "楚格": {
    "id": "楚格"
  },
  "拉各斯": {
    "id": "拉各斯"
  },
  "伊斯特拉": {
    "id": "伊斯特拉"
  },
  "猜也奔": {
    "id": "猜也奔"
  },
  "巴亚尔塔港": {
    "id": "巴亚尔塔港"
  },
  "俄罗斯": {
    "id": "俄罗斯"
  },
  "新爱尔兰": {
    "id": "新爱尔兰"
  },
  "拜蒂克洛": {
    "id": "拜蒂克洛"
  },
  "普埃布拉": {
    "id": "普埃布拉"
  },
  "阿森松岛": {
    "id": "阿森松岛"
  },
  "阿努拉德普勒": {
    "id": "阿努拉德普勒"
  },
  "曼德勒省": {
    "id": "曼德勒省"
  },
  "马亚里": {
    "id": "马亚里"
  },
  "part28": {
    "id": "part28"
  },
  "斯多斯特姆": {
    "id": "斯多斯特姆"
  },
  "克罗斯诺": {
    "id": "克罗斯诺"
  },
  "拉利伯塔德": {
    "id": "拉利伯塔德"
  },
  "宾格尔": {
    "id": "宾格尔"
  },
  "姆博穆": {
    "id": "姆博穆"
  },
  "萨摩斯": {
    "id": "萨摩斯"
  },
  "梅斯": {
    "id": "梅斯"
  },
  "上特拉斯山": {
    "id": "上特拉斯山"
  },
  "切尔卡瑟": {
    "id": "切尔卡瑟"
  },
  "拜勒加": {
    "id": "拜勒加"
  },
  "岩手": {
    "id": "岩手"
  },
  "姆特瓦拉": {
    "id": "姆特瓦拉"
  },
  "卡拉扎尔": {
    "id": "卡拉扎尔"
  },
  "塔什库梅尔": {
    "id": "塔什库梅尔"
  },
  "奥法利": {
    "id": "奥法利"
  },
  "帕尔杜比采": {
    "id": "帕尔杜比采"
  },
  "巴黎": {
    "id": "巴黎"
  },
  "上德梅拉拉-伯比斯": {
    "id": "上德梅拉拉-伯比斯"
  },
  "谢普斯通港": {
    "id": "谢普斯通港"
  },
  "提济乌祖": {
    "id": "提济乌祖"
  },
  "贡布": {
    "id": "贡布"
  },
  "北苏瓦迪瓦": {
    "id": "北苏瓦迪瓦"
  },
  "四川省": {
    "id": "四川省"
  },
  "墨西卡利": {
    "id": "墨西卡利"
  },
  "希贝尼克-克宁": {
    "id": "希贝尼克-克宁"
  },
  "乌迪内": {
    "id": "乌迪内"
  },
  "费萨拉巴德": {
    "id": "费萨拉巴德"
  },
  "斯波德涅波萨夫": {
    "id": "斯波德涅波萨夫"
  },
  "斯基克达": {
    "id": "斯基克达"
  },
  "瓦瓦乌": {
    "id": "瓦瓦乌"
  },
  "南马洛斯马杜卢": {
    "id": "南马洛斯马杜卢"
  },
  "艾因·蒂姆尚特": {
    "id": "艾因·蒂姆尚特"
  },
  "巴马科首都区": {
    "id": "巴马科首都区"
  },
  "哥本哈根": {
    "id": "哥本哈根"
  },
  "波塔罗-锡帕鲁尼": {
    "id": "波塔罗-锡帕鲁尼"
  },
  "塞拉利昂": {
    "id": "塞拉利昂"
  },
  "比耶": {
    "id": "比耶"
  },
  "圣多明戈": {
    "id": "圣多明戈"
  },
  "埃斯特利": {
    "id": "埃斯特利"
  },
  "希拉克": {
    "id": "希拉克"
  },
  "刚果": {
    "id": "刚果"
  },
  "塔里夫": {
    "id": "塔里夫"
  },
  "切尔诺夫策": {
    "id": "切尔诺夫策"
  },
  "巴伊布尔特": {
    "id": "巴伊布尔特"
  },
  "蓬塔雷纳斯": {
    "id": "蓬塔雷纳斯"
  },
  "索博尔奇-索特马尔-贝拉格": {
    "id": "索博尔奇-索特马尔-贝拉格"
  },
  "诺特拉尼": {
    "id": "诺特拉尼"
  },
  "喀布尔": {
    "id": "喀布尔"
  },
  "路易斯安那": {
    "id": "路易斯安那"
  },
  "卡什卡达里亚": {
    "id": "卡什卡达里亚"
  },
  "冲绳": {
    "id": "冲绳"
  },
  "斯里兰卡": {
    "id": "斯里兰卡"
  },
  "玻利维亚": {
    "id": "玻利维亚"
  },
  "阿利坎特": {
    "id": "阿利坎特"
  },
  "希腊": {
    "id": "希腊"
  },
  "苏赫巴托尔": {
    "id": "苏赫巴托尔"
  },
  "纳沃伊": {
    "id": "纳沃伊"
  },
  "桑布卢": {
    "id": "桑布卢"
  },
  "雅典": {
    "id": "雅典"
  },
  "新西兰": {
    "id": "新西兰"
  },
  "宰格万": {
    "id": "宰格万"
  },
  "乌里扬诺夫斯克": {
    "id": "乌里扬诺夫斯克"
  },
  "伊巴丹": {
    "id": "伊巴丹"
  },
  "蒙巴萨": {
    "id": "蒙巴萨"
  },
  "波哥大首都区": {
    "id": "波哥大首都区"
  },
  "科布多": {
    "id": "科布多"
  },
  "尼亚美市": {
    "id": "尼亚美市"
  },
  "阿拉戈斯": {
    "id": "阿拉戈斯"
  },
  "瓜德罗普": {
    "id": "瓜德罗普"
  },
  "新塞哥维亚": {
    "id": "新塞哥维亚"
  },
  "阿恩斯贝格": {
    "id": "阿恩斯贝格"
  },
  "豪伊杜-比豪尔": {
    "id": "豪伊杜-比豪尔"
  },
  "霹雳": {
    "id": "霹雳"
  },
  "奥兰": {
    "id": "奥兰"
  },
  "鲁赛法": {
    "id": "鲁赛法"
  },
  "凯鲁万": {
    "id": "凯鲁万"
  },
  "赫利赞": {
    "id": "赫利赞"
  },
  "黑龙江省": {
    "id": "黑龙江省"
  },
  "萨拉曼卡": {
    "id": "萨拉曼卡"
  },
  "博尔古": {
    "id": "博尔古"
  },
  "拉里奥哈": {
    "id": "拉里奥哈"
  },
  "中部": {
    "id": "中部"
  },
  "科尔多瓦": {
    "id": "科尔多瓦"
  },
  "马辛迪": {
    "id": "马辛迪"
  },
  "中加里曼丹": {
    "id": "中加里曼丹"
  },
  "贵州省": {
    "id": "贵州省"
  },
  "奥伦塞": {
    "id": "奥伦塞"
  },
  "斯科耐": {
    "id": "斯科耐"
  },
  "拉布蒂": {
    "id": "拉布蒂"
  },
  "皮特什蒂": {
    "id": "皮特什蒂"
  },
  "滨海": {
    "id": "滨海"
  },
  "麦加": {
    "id": "麦加"
  },
  "拉赫蒂": {
    "id": "拉赫蒂"
  },
  "part29": {
    "id": "part29"
  },
  "赫尔辛基": {
    "id": "赫尔辛基"
  },
  "凯帕拉": {
    "id": "凯帕拉"
  },
  "米戈利": {
    "id": "米戈利"
  },
  "斯普利特-达尔马提亚": {
    "id": "斯普利特-达尔马提亚"
  },
  "施维茨": {
    "id": "施维茨"
  },
  "卡塞林": {
    "id": "卡塞林"
  },
  "圣约翰斯": {
    "id": "圣约翰斯"
  },
  "涅里": {
    "id": "涅里"
  },
  "下诺夫哥罗德": {
    "id": "下诺夫哥罗德"
  },
  "夏亚": {
    "id": "夏亚"
  },
  "帕福斯": {
    "id": "帕福斯"
  },
  "拉脱维亚": {
    "id": "拉脱维亚"
  },
  "萨沃纳": {
    "id": "萨沃纳"
  },
  "拉贝": {
    "id": "拉贝"
  },
  "卡巴莱": {
    "id": "卡巴莱"
  },
  "鲁亨盖里": {
    "id": "鲁亨盖里"
  },
  "乌兹根": {
    "id": "乌兹根"
  },
  "布拉瓦约": {
    "id": "布拉瓦约"
  },
  "北大年": {
    "id": "北大年"
  },
  "阿普里马克": {
    "id": "阿普里马克"
  },
  "萨拉马卡": {
    "id": "萨拉马卡"
  },
  "科罗萨尔": {
    "id": "科罗萨尔"
  },
  "圣克鲁斯": {
    "id": "圣克鲁斯"
  },
  "蒂罗尔": {
    "id": "蒂罗尔"
  },
  "蒙特利尔": {
    "id": "蒙特利尔"
  },
  "阿里萨比赫区": {
    "id": "阿里萨比赫区"
  },
  "因弗卡吉尔": {
    "id": "因弗卡吉尔"
  },
  "滨海阿连特茹": {
    "id": "滨海阿连特茹"
  },
  "俄克拉荷马": {
    "id": "俄克拉荷马"
  },
  "鲁昂": {
    "id": "鲁昂"
  },
  "韦茨肖克": {
    "id": "韦茨肖克"
  },
  "卢萨卡": {
    "id": "卢萨卡"
  },
  "亚利桑那": {
    "id": "亚利桑那"
  },
  "德克萨斯": {
    "id": "德克萨斯"
  },
  "奥罗米亚": {
    "id": "奥罗米亚"
  },
  "维查达": {
    "id": "维查达"
  },
  "图尔库": {
    "id": "图尔库"
  },
  "复活节岛": {
    "id": "复活节岛"
  },
  "奇马尔特南戈": {
    "id": "奇马尔特南戈"
  },
  "乌兰乌德": {
    "id": "乌兰乌德"
  },
  "文莱": {
    "id": "文莱"
  },
  "摩尔多瓦": {
    "id": "摩尔多瓦"
  },
  "特拉扎": {
    "id": "特拉扎"
  },
  "阿克苏": {
    "id": "阿克苏"
  },
  "马纳比": {
    "id": "马纳比"
  },
  "山形": {
    "id": "山形"
  },
  "青年岛特区": {
    "id": "青年岛特区"
  },
  "鹿特丹": {
    "id": "鹿特丹"
  },
  "密西西比": {
    "id": "密西西比"
  },
  "卢塞恩": {
    "id": "卢塞恩"
  },
  "布希亚": {
    "id": "布希亚"
  },
  "萨卡特佩克斯": {
    "id": "萨卡特佩克斯"
  },
  "比雷埃夫斯": {
    "id": "比雷埃夫斯"
  },
  "伊萨贝尔": {
    "id": "伊萨贝尔"
  },
  "乌斯季奥尔登斯基": {
    "id": "乌斯季奥尔登斯基"
  },
  "波莱": {
    "id": "波莱"
  },
  "杜拉斯诺": {
    "id": "杜拉斯诺"
  },
  "巴伊亚": {
    "id": "巴伊亚"
  },
  "马耳他": {
    "id": "马耳他"
  },
  "米兰达": {
    "id": "米兰达"
  },
  "若开邦": {
    "id": "若开邦"
  },
  "乌法": {
    "id": "乌法"
  },
  "卢戈": {
    "id": "卢戈"
  },
  "布雷达斯多普": {
    "id": "布雷达斯多普"
  },
  "南红海": {
    "id": "南红海"
  },
  "雅库茨克": {
    "id": "雅库茨克"
  },
  "纳门滕加": {
    "id": "纳门滕加"
  },
  "桑吉": {
    "id": "桑吉"
  },
  "圣诞岛": {
    "id": "圣诞岛"
  },
  "马德雷德迪奥斯": {
    "id": "马德雷德迪奥斯"
  },
  "马尤盖": {
    "id": "马尤盖"
  },
  "波多西": {
    "id": "波多西"
  },
  "埃德蒙顿": {
    "id": "埃德蒙顿"
  },
  "赛宋本行政特区": {
    "id": "赛宋本行政特区"
  },
  "春武里": {
    "id": "春武里"
  },
  "谢里夫": {
    "id": "谢里夫"
  },
  "加尔各答": {
    "id": "加尔各答"
  },
  "昌克勒": {
    "id": "昌克勒"
  },
  "瓦武尼亚": {
    "id": "瓦武尼亚"
  },
  "斯武普斯克": {
    "id": "斯武普斯克"
  },
  "肯考迪娅": {
    "id": "肯考迪娅"
  },
  "卢扎": {
    "id": "卢扎"
  },
  "蒙塔纳": {
    "id": "蒙塔纳"
  },
  "波多黎各": {
    "id": "波多黎各"
  },
  "墨西哥城": {
    "id": "墨西哥城"
  },
  "温尼伯": {
    "id": "温尼伯"
  },
  "维堡": {
    "id": "维堡"
  },
  "格利维采": {
    "id": "格利维采"
  },
  "列宁诺戈尔斯克": {
    "id": "列宁诺戈尔斯克"
  },
  "比哈尔邦": {
    "id": "比哈尔邦"
  },
  "喀拉拉邦": {
    "id": "喀拉拉邦"
  },
  "果阿邦": {
    "id": "果阿邦"
  },
  "达德拉-纳加尔哈维利": {
    "id": "达德拉-纳加尔哈维利"
  },
  "梅加拉亚邦": {
    "id": "梅加拉亚邦"
  },
  "贾坎德邦": {
    "id": "贾坎德邦"
  },
  "拉克沙群岛": {
    "id": "拉克沙群岛"
  },
  "恰蒂斯加尔邦": {
    "id": "恰蒂斯加尔邦"
  },
  "西孟加拉邦": {
    "id": "西孟加拉邦"
  },
  "拉贾斯坦邦": {
    "id": "拉贾斯坦邦"
  },
  "旁遮普邦": {
    "id": "旁遮普邦"
  },
  "中央邦": {
    "id": "中央邦"
  },
  "德里": {
    "id": "德里"
  },
  "查谟-克什米尔邦": {
    "id": "查谟-克什米尔邦"
  },
  "哈里亚纳邦": {
    "id": "哈里亚纳邦"
  },
  "阿萨姆邦": {
    "id": "阿萨姆邦"
  },
  "北阿坎德邦": {
    "id": "北阿坎德邦"
  },
  "锡金邦": {
    "id": "锡金邦"
  },
  "特伦甘纳邦": {
    "id": "特伦甘纳邦"
  },
  "安得拉邦": {
    "id": "安得拉邦"
  },
  "古吉拉特邦": {
    "id": "古吉拉特邦"
  },
  "泰米尔纳德邦": {
    "id": "泰米尔纳德邦"
  },
  "北方邦": {
    "id": "北方邦"
  },
  "曼尼普尔邦": {
    "id": "曼尼普尔邦"
  },
  "米佐拉姆邦": {
    "id": "米佐拉姆邦"
  },
  "特里普拉邦": {
    "id": "特里普拉邦"
  },
  "喜马偕尔邦": {
    "id": "喜马偕尔邦"
  },
  "马哈拉施特拉邦": {
    "id": "马哈拉施特拉邦"
  },
  "安达曼-尼科巴群岛": {
    "id": "安达曼-尼科巴群岛"
  },
  "卡纳塔克邦": {
    "id": "卡纳塔克邦"
  },
  "那加兰邦": {
    "id": "那加兰邦"
  },
  "奥里萨邦": {
    "id": "奥里萨邦"
  },
  "达曼-第乌": {
    "id": "达曼-第乌"
  }
});
export default mapMassages;